[
  {
    "icao": "EHAM",
    "iata": "AMS",
    "name": "Amsterdam Schiphol",
    "city": "Amsterdam",
    "country": "NL",
    "lat": 52.31
  },
  {
    "icao": "EHLE",
    "iata": "LEY",
    "name": "Lelystad Airport",
    "city": "Lelystad",
    "country": "NL",
    "lat": 52.46
  },
  {
    "icao": "EHRD",
    "iata": "RTM",
    "name": "Rotterdam The Hague",
    "city": "Rotterdam",
    "country": "NL",
    "lat": 51.96
  },
  {
    "icao": "EHEH",
    "iata": "EIN",
    "name": "Eindhoven Airport",
    "city": "Eindhoven",
    "country": "NL",
    "lat": 51.45
  },
  {
    "icao": "EHGG",
    "iata": "GRQ",
    "name": "Groningen Eelde",
    "city": "Groningen",
    "country": "NL",
    "lat": 53.13
  },
  {
    "icao": "EHBK",
    "iata": "MST",
    "name": "Maastricht Aachen",
    "city": "Maastricht",
    "country": "NL",
    "lat": 50.91
  },
  {
    "icao": "EHTW",
    "iata": "ENS",
    "name": "Twente Airport",
    "city": "Enschede",
    "country": "NL",
    "lat": 52.28
  },
  {
    "icao": "EDDF",
    "iata": "FRA",
    "name": "Frankfurt Main",
    "city": "Frankfurt",
    "country": "DE",
    "lat": 50.03
  },
  {
    "icao": "EDDM",
    "iata": "MUC",
    "name": "Munich Franz Josef Strauss",
    "city": "Munich",
    "country": "DE",
    "lat": 48.35
  },
  {
    "icao": "EDDB",
    "iata": "BER",
    "name": "Berlin Brandenburg",
    "city": "Berlin",
    "country": "DE",
    "lat": 52.37
  },
  {
    "icao": "EDDL",
    "iata": "DUS",
    "name": "Dusseldorf",
    "city": "Dusseldorf",
    "country": "DE",
    "lat": 51.29
  },
  {
    "icao": "EDDH",
    "iata": "HAM",
    "name": "Hamburg",
    "city": "Hamburg",
    "country": "DE",
    "lat": 53.63
  },
  {
    "icao": "EDDK",
    "iata": "CGN",
    "name": "Cologne Bonn",
    "city": "Cologne",
    "country": "DE",
    "lat": 50.87
  },
  {
    "icao": "EDDS",
    "iata": "STR",
    "name": "Stuttgart",
    "city": "Stuttgart",
    "country": "DE",
    "lat": 48.69
  },
  {
    "icao": "EDDW",
    "iata": "BRE",
    "name": "Bremen",
    "city": "Bremen",
    "country": "DE",
    "lat": 53.05
  },
  {
    "icao": "EDDN",
    "iata": "NUE",
    "name": "Nuremberg",
    "city": "Nuremberg",
    "country": "DE",
    "lat": 49.5
  },
  {
    "icao": "EDDP",
    "iata": "LEJ",
    "name": "Leipzig Halle",
    "city": "Leipzig",
    "country": "DE",
    "lat": 51.42
  },
  {
    "icao": "EDDT",
    "iata": "TXL",
    "name": "Berlin Tegel",
    "city": "Berlin",
    "country": "DE",
    "lat": 52.56
  },
  {
    "icao": "EDDV",
    "iata": "HAJ",
    "name": "Hannover",
    "city": "Hannover",
    "country": "DE",
    "lat": 52.46
  },
  {
    "icao": "EDDC",
    "iata": "DRS",
    "name": "Dresden",
    "city": "Dresden",
    "country": "DE",
    "lat": 51.13
  },
  {
    "icao": "EDDE",
    "iata": "ERF",
    "name": "Erfurt Weimar",
    "city": "Erfurt",
    "country": "DE",
    "lat": 50.98
  },
  {
    "icao": "EDDG",
    "iata": "FMO",
    "name": "Munster Osnabruck",
    "city": "Munster",
    "country": "DE",
    "lat": 52.13
  },
  {
    "icao": "EDDR",
    "iata": "SCN",
    "name": "Saarbrucken",
    "city": "Saarbrucken",
    "country": "DE",
    "lat": 49.21
  },
  {
    "icao": "EDLW",
    "iata": "DTM",
    "name": "Dortmund",
    "city": "Dortmund",
    "country": "DE",
    "lat": 51.52
  },
  {
    "icao": "EDFH",
    "iata": "HHN",
    "name": "Frankfurt Hahn",
    "city": "Hahn",
    "country": "DE",
    "lat": 49.95
  },
  {
    "icao": "EGLL",
    "iata": "LHR",
    "name": "London Heathrow",
    "city": "London",
    "country": "GB",
    "lat": 51.47
  },
  {
    "icao": "EGKK",
    "iata": "LGW",
    "name": "London Gatwick",
    "city": "London",
    "country": "GB",
    "lat": 51.15
  },
  {
    "icao": "EGSS",
    "iata": "STN",
    "name": "London Stansted",
    "city": "London",
    "country": "GB",
    "lat": 51.89
  },
  {
    "icao": "EGLC",
    "iata": "LCY",
    "name": "London City",
    "city": "London",
    "country": "GB",
    "lat": 51.51
  },
  {
    "icao": "EGCC",
    "iata": "MAN",
    "name": "Manchester",
    "city": "Manchester",
    "country": "GB",
    "lat": 53.36
  },
  {
    "icao": "EGBB",
    "iata": "BHX",
    "name": "Birmingham",
    "city": "Birmingham",
    "country": "GB",
    "lat": 52.45
  },
  {
    "icao": "EGPH",
    "iata": "EDI",
    "name": "Edinburgh",
    "city": "Edinburgh",
    "country": "GB",
    "lat": 55.95
  },
  {
    "icao": "EGPF",
    "iata": "GLA",
    "name": "Glasgow",
    "city": "Glasgow",
    "country": "GB",
    "lat": 55.87
  },
  {
    "icao": "EGGW",
    "iata": "LTN",
    "name": "London Luton",
    "city": "London",
    "country": "GB",
    "lat": 51.87
  },
  {
    "icao": "EGGD",
    "iata": "BRS",
    "name": "Bristol",
    "city": "Bristol",
    "country": "GB",
    "lat": 51.38
  },
  {
    "icao": "EGNX",
    "iata": "EMA",
    "name": "East Midlands",
    "city": "Nottingham",
    "country": "GB",
    "lat": 52.83
  },
  {
    "icao": "EGNT",
    "iata": "NCL",
    "name": "Newcastle",
    "city": "Newcastle",
    "country": "GB",
    "lat": 55.04
  },
  {
    "icao": "EGGP",
    "iata": "LPL",
    "name": "Liverpool John Lennon",
    "city": "Liverpool",
    "country": "GB",
    "lat": 53.34
  },
  {
    "icao": "EGHI",
    "iata": "SOU",
    "name": "Southampton",
    "city": "Southampton",
    "country": "GB",
    "lat": 50.95
  },
  {
    "icao": "EGPD",
    "iata": "ABZ",
    "name": "Aberdeen",
    "city": "Aberdeen",
    "country": "GB",
    "lat": 57.2
  },
  {
    "icao": "EGTE",
    "iata": "EXT",
    "name": "Exeter",
    "city": "Exeter",
    "country": "GB",
    "lat": 50.73
  },
  {
    "icao": "EGPK",
    "iata": "PIK",
    "name": "Glasgow Prestwick",
    "city": "Glasgow",
    "country": "GB",
    "lat": 55.51
  },
  {
    "icao": "EGSH",
    "iata": "NWI",
    "name": "Norwich",
    "city": "Norwich",
    "country": "GB",
    "lat": 52.68
  },
  {
    "icao": "EGNM",
    "iata": "LBA",
    "name": "Leeds Bradford",
    "city": "Leeds",
    "country": "GB",
    "lat": 53.87
  },
  {
    "icao": "LFPG",
    "iata": "CDG",
    "name": "Paris Charles de Gaulle",
    "city": "Paris",
    "country": "FR",
    "lat": 49.01
  },
  {
    "icao": "LFPO",
    "iata": "ORY",
    "name": "Paris Orly",
    "city": "Paris",
    "country": "FR",
    "lat": 48.73
  },
  {
    "icao": "LFML",
    "iata": "MRS",
    "name": "Marseille Provence",
    "city": "Marseille",
    "country": "FR",
    "lat": 43.44
  },
  {
    "icao": "LFLL",
    "iata": "LYS",
    "name": "Lyon Saint-Exupery",
    "city": "Lyon",
    "country": "FR",
    "lat": 45.73
  },
  {
    "icao": "LFBO",
    "iata": "TLS",
    "name": "Toulouse Blagnac",
    "city": "Toulouse",
    "country": "FR",
    "lat": 43.63
  },
  {
    "icao": "LFMN",
    "iata": "NCE",
    "name": "Nice Cote d'Azur",
    "city": "Nice",
    "country": "FR",
    "lat": 43.66
  },
  {
    "icao": "LFBD",
    "iata": "BOD",
    "name": "Bordeaux Merignac",
    "city": "Bordeaux",
    "country": "FR",
    "lat": 44.83
  },
  {
    "icao": "LFRS",
    "iata": "NTE",
    "name": "Nantes Atlantique",
    "city": "Nantes",
    "country": "FR",
    "lat": 47.16
  },
  {
    "icao": "LFSB",
    "iata": "BSL",
    "name": "Basel Mulhouse",
    "city": "Basel",
    "country": "FR",
    "lat": 47.59
  },
  {
    "icao": "LFST",
    "iata": "SXB",
    "name": "Strasbourg",
    "city": "Strasbourg",
    "country": "FR",
    "lat": 48.54
  },
  {
    "icao": "LFRB",
    "iata": "BES",
    "name": "Brest Bretagne",
    "city": "Brest",
    "country": "FR",
    "lat": 48.45
  },
  {
    "icao": "LFPB",
    "iata": "LBG",
    "name": "Paris Le Bourget",
    "city": "Paris",
    "country": "FR",
    "lat": 48.97
  },
  {
    "icao": "LFBZ",
    "iata": "BIQ",
    "name": "Biarritz Bayonne",
    "city": "Biarritz",
    "country": "FR",
    "lat": 43.47
  },
  {
    "icao": "LFLC",
    "iata": "CFE",
    "name": "Clermont-Ferrand Auvergne",
    "city": "Clermont-Ferrand",
    "country": "FR",
    "lat": 45.79
  },
  {
    "icao": "LFMP",
    "iata": "PGF",
    "name": "Perpignan Rivesaltes",
    "city": "Perpignan",
    "country": "FR",
    "lat": 42.74
  },
  {
    "icao": "LFMT",
    "iata": "MPL",
    "name": "Montpellier Mediterranee",
    "city": "Montpellier",
    "country": "FR",
    "lat": 43.58
  },
  {
    "icao": "LFRN",
    "iata": "RNS",
    "name": "Rennes Saint-Jacques",
    "city": "Rennes",
    "country": "FR",
    "lat": 48.07
  },
  {
    "icao": "LEMD",
    "iata": "MAD",
    "name": "Madrid Barajas",
    "city": "Madrid",
    "country": "ES",
    "lat": 40.47
  },
  {
    "icao": "LEBL",
    "iata": "BCN",
    "name": "Barcelona El Prat",
    "city": "Barcelona",
    "country": "ES",
    "lat": 41.3
  },
  {
    "icao": "LEPA",
    "iata": "PMI",
    "name": "Palma de Mallorca",
    "city": "Palma",
    "country": "ES",
    "lat": 39.55
  },
  {
    "icao": "LEAL",
    "iata": "ALC",
    "name": "Alicante",
    "city": "Alicante",
    "country": "ES",
    "lat": 38.28
  },
  {
    "icao": "LEMG",
    "iata": "AGP",
    "name": "Malaga",
    "city": "Malaga",
    "country": "ES",
    "lat": 36.67
  },
  {
    "icao": "LEZL",
    "iata": "SVQ",
    "name": "Seville",
    "city": "Seville",
    "country": "ES",
    "lat": 37.42
  },
  {
    "icao": "LEVC",
    "iata": "VLC",
    "name": "Valencia",
    "city": "Valencia",
    "country": "ES",
    "lat": 39.49
  },
  {
    "icao": "GCTS",
    "iata": "TFS",
    "name": "Tenerife South",
    "city": "Tenerife",
    "country": "ES",
    "lat": 28.04
  },
  {
    "icao": "GCXO",
    "iata": "TFN",
    "name": "Tenerife North",
    "city": "Tenerife",
    "country": "ES",
    "lat": 28.48
  },
  {
    "icao": "GCLP",
    "iata": "LPA",
    "name": "Gran Canaria",
    "city": "Las Palmas",
    "country": "ES",
    "lat": 27.93
  },
  {
    "icao": "GCFV",
    "iata": "FUE",
    "name": "Fuerteventura",
    "city": "Fuerteventura",
    "country": "ES",
    "lat": 28.45
  },
  {
    "icao": "GCRR",
    "iata": "ACE",
    "name": "Lanzarote",
    "city": "Lanzarote",
    "country": "ES",
    "lat": 28.95
  },
  {
    "icao": "LEBB",
    "iata": "BIO",
    "name": "Bilbao",
    "city": "Bilbao",
    "country": "ES",
    "lat": 43.3
  },
  {
    "icao": "LESO",
    "iata": "EAS",
    "name": "San Sebastian",
    "city": "San Sebastian",
    "country": "ES",
    "lat": 43.36
  },
  {
    "icao": "LEST",
    "iata": "SCQ",
    "name": "Santiago de Compostela",
    "city": "Santiago",
    "country": "ES",
    "lat": 42.9
  },
  {
    "icao": "LEGE",
    "iata": "GRO",
    "name": "Girona Costa Brava",
    "city": "Girona",
    "country": "ES",
    "lat": 41.9
  },
  {
    "icao": "LEIB",
    "iata": "IBZ",
    "name": "Ibiza",
    "city": "Ibiza",
    "country": "ES",
    "lat": 38.87
  },
  {
    "icao": "LIRF",
    "iata": "FCO",
    "name": "Rome Fiumicino",
    "city": "Rome",
    "country": "IT",
    "lat": 41.8
  },
  {
    "icao": "LIMC",
    "iata": "MXP",
    "name": "Milan Malpensa",
    "city": "Milan",
    "country": "IT",
    "lat": 45.63
  },
  {
    "icao": "LIME",
    "iata": "BGY",
    "name": "Milan Bergamo",
    "city": "Milan",
    "country": "IT",
    "lat": 45.67
  },
  {
    "icao": "LIPZ",
    "iata": "VCE",
    "name": "Venice Marco Polo",
    "city": "Venice",
    "country": "IT",
    "lat": 45.51
  },
  {
    "icao": "LIRN",
    "iata": "NAP",
    "name": "Naples",
    "city": "Naples",
    "country": "IT",
    "lat": 40.88
  },
  {
    "icao": "LIML",
    "iata": "LIN",
    "name": "Milan Linate",
    "city": "Milan",
    "country": "IT",
    "lat": 45.45
  },
  {
    "icao": "LIPE",
    "iata": "BLQ",
    "name": "Bologna",
    "city": "Bologna",
    "country": "IT",
    "lat": 44.54
  },
  {
    "icao": "LIRA",
    "iata": "CIA",
    "name": "Rome Ciampino",
    "city": "Rome",
    "country": "IT",
    "lat": 41.8
  },
  {
    "icao": "LICJ",
    "iata": "PMO",
    "name": "Palermo",
    "city": "Palermo",
    "country": "IT",
    "lat": 38.18
  },
  {
    "icao": "LICC",
    "iata": "CTA",
    "name": "Catania Fontanarossa",
    "city": "Catania",
    "country": "IT",
    "lat": 37.47
  },
  {
    "icao": "LIPX",
    "iata": "VRN",
    "name": "Verona Villafranca",
    "city": "Verona",
    "country": "IT",
    "lat": 45.4
  },
  {
    "icao": "LIRP",
    "iata": "PSA",
    "name": "Pisa Galileo Galilei",
    "city": "Pisa",
    "country": "IT",
    "lat": 43.68
  },
  {
    "icao": "LIBD",
    "iata": "BRI",
    "name": "Bari Karol Wojtyla",
    "city": "Bari",
    "country": "IT",
    "lat": 41.14
  },
  {
    "icao": "LIRQ",
    "iata": "FLR",
    "name": "Florence Peretola",
    "city": "Florence",
    "country": "IT",
    "lat": 43.81
  },
  {
    "icao": "LIMF",
    "iata": "TRN",
    "name": "Turin Caselle",
    "city": "Turin",
    "country": "IT",
    "lat": 45.2
  },
  {
    "icao": "LIPQ",
    "iata": "TRS",
    "name": "Trieste Friuli Venezia Giulia",
    "city": "Trieste",
    "country": "IT",
    "lat": 45.83
  },
  {
    "icao": "LSZH",
    "iata": "ZRH",
    "name": "Zurich",
    "city": "Zurich",
    "country": "CH",
    "lat": 47.46
  },
  {
    "icao": "LSGG",
    "iata": "GVA",
    "name": "Geneva",
    "city": "Geneva",
    "country": "CH",
    "lat": 46.24
  },
  {
    "icao": "LSZA",
    "iata": "LUG",
    "name": "Lugano",
    "city": "Lugano",
    "country": "CH",
    "lat": 46.0
  },
  {
    "icao": "LSZB",
    "iata": "BRN",
    "name": "Bern",
    "city": "Bern",
    "country": "CH",
    "lat": 46.91
  },
  {
    "icao": "LOWW",
    "iata": "VIE",
    "name": "Vienna",
    "city": "Vienna",
    "country": "AT",
    "lat": 48.11
  },
  {
    "icao": "LOWG",
    "iata": "GRZ",
    "name": "Graz",
    "city": "Graz",
    "country": "AT",
    "lat": 46.99
  },
  {
    "icao": "LOWI",
    "iata": "INN",
    "name": "Innsbruck",
    "city": "Innsbruck",
    "country": "AT",
    "lat": 47.26
  },
  {
    "icao": "LOWS",
    "iata": "SZG",
    "name": "Salzburg",
    "city": "Salzburg",
    "country": "AT",
    "lat": 47.79
  },
  {
    "icao": "LOWL",
    "iata": "LNZ",
    "name": "Linz Blue Danube",
    "city": "Linz",
    "country": "AT",
    "lat": 48.23
  },
  {
    "icao": "LOWK",
    "iata": "KLU",
    "name": "Klagenfurt",
    "city": "Klagenfurt",
    "country": "AT",
    "lat": 46.64
  },
  {
    "icao": "EBBR",
    "iata": "BRU",
    "name": "Brussels",
    "city": "Brussels",
    "country": "BE",
    "lat": 50.9
  },
  {
    "icao": "EBCI",
    "iata": "CRL",
    "name": "Brussels South Charleroi",
    "city": "Charleroi",
    "country": "BE",
    "lat": 50.46
  },
  {
    "icao": "EBOS",
    "iata": "OST",
    "name": "Ostend Bruges",
    "city": "Ostend",
    "country": "BE",
    "lat": 51.2
  },
  {
    "icao": "EBLG",
    "iata": "LGG",
    "name": "Liege",
    "city": "Liege",
    "country": "BE",
    "lat": 50.64
  },
  {
    "icao": "EBAW",
    "iata": "ANR",
    "name": "Antwerp",
    "city": "Antwerp",
    "country": "BE",
    "lat": 51.19
  },
  {
    "icao": "ELLX",
    "iata": "LUX",
    "name": "Luxembourg",
    "city": "Luxembourg",
    "country": "LU",
    "lat": 49.63
  },
  {
    "icao": "EKCH",
    "iata": "CPH",
    "name": "Copenhagen Kastrup",
    "city": "Copenhagen",
    "country": "DK",
    "lat": 55.62
  },
  {
    "icao": "EKBI",
    "iata": "BLL",
    "name": "Billund",
    "city": "Billund",
    "country": "DK",
    "lat": 55.74
  },
  {
    "icao": "EKYT",
    "iata": "AAL",
    "name": "Aalborg",
    "city": "Aalborg",
    "country": "DK",
    "lat": 57.09
  },
  {
    "icao": "ESSA",
    "iata": "ARN",
    "name": "Stockholm Arlanda",
    "city": "Stockholm",
    "country": "SE",
    "lat": 59.65
  },
  {
    "icao": "ESGG",
    "iata": "GOT",
    "name": "Gothenburg Landvetter",
    "city": "Gothenburg",
    "country": "SE",
    "lat": 57.66
  },
  {
    "icao": "ESMS",
    "iata": "MMX",
    "name": "Malmo Sturup",
    "city": "Malmo",
    "country": "SE",
    "lat": 55.54
  },
  {
    "icao": "ESKN",
    "iata": "NYO",
    "name": "Stockholm Skavsta",
    "city": "Stockholm",
    "country": "SE",
    "lat": 58.79
  },
  {
    "icao": "ESSP",
    "iata": "NRK",
    "name": "Norrkoping Kungsangen",
    "city": "Norrkoping",
    "country": "SE",
    "lat": 58.59
  },
  {
    "icao": "ENGM",
    "iata": "OSL",
    "name": "Oslo Gardermoen",
    "city": "Oslo",
    "country": "NO",
    "lat": 60.2
  },
  {
    "icao": "ENBR",
    "iata": "BGO",
    "name": "Bergen Flesland",
    "city": "Bergen",
    "country": "NO",
    "lat": 60.29
  },
  {
    "icao": "ENZV",
    "iata": "SVG",
    "name": "Stavanger Sola",
    "city": "Stavanger",
    "country": "NO",
    "lat": 58.88
  },
  {
    "icao": "ENVA",
    "iata": "TRD",
    "name": "Trondheim Vaernes",
    "city": "Trondheim",
    "country": "NO",
    "lat": 63.46
  },
  {
    "icao": "ENTC",
    "iata": "TOS",
    "name": "Tromso Langnes",
    "city": "Tromso",
    "country": "NO",
    "lat": 69.68
  },
  {
    "icao": "ENBO",
    "iata": "BOO",
    "name": "Bodo",
    "city": "Bodo",
    "country": "NO",
    "lat": 67.27
  },
  {
    "icao": "EFHK",
    "iata": "HEL",
    "name": "Helsinki Vantaa",
    "city": "Helsinki",
    "country": "FI",
    "lat": 60.32
  },
  {
    "icao": "EFOU",
    "iata": "OUL",
    "name": "Oulu",
    "city": "Oulu",
    "country": "FI",
    "lat": 64.93
  },
  {
    "icao": "EFTU",
    "iata": "TKU",
    "name": "Turku",
    "city": "Turku",
    "country": "FI",
    "lat": 60.51
  },
  {
    "icao": "EFTP",
    "iata": "TMP",
    "name": "Tampere Pirkkala",
    "city": "Tampere",
    "country": "FI",
    "lat": 61.41
  },
  {
    "icao": "EFRO",
    "iata": "RVN",
    "name": "Rovaniemi",
    "city": "Rovaniemi",
    "country": "FI",
    "lat": 66.56
  },
  {
    "icao": "EPWA",
    "iata": "WAW",
    "name": "Warsaw Chopin",
    "city": "Warsaw",
    "country": "PL",
    "lat": 52.17
  },
  {
    "icao": "EPKK",
    "iata": "KRK",
    "name": "Krakow Balice",
    "city": "Krakow",
    "country": "PL",
    "lat": 50.08
  },
  {
    "icao": "EPGD",
    "iata": "GDN",
    "name": "Gdansk Lech Walesa",
    "city": "Gdansk",
    "country": "PL",
    "lat": 54.38
  },
  {
    "icao": "EPWR",
    "iata": "WRO",
    "name": "Wroclaw Copernicus",
    "city": "Wroclaw",
    "country": "PL",
    "lat": 51.1
  },
  {
    "icao": "EPPO",
    "iata": "POZ",
    "name": "Poznan Lawica",
    "city": "Poznan",
    "country": "PL",
    "lat": 52.42
  },
  {
    "icao": "EPKT",
    "iata": "KTW",
    "name": "Katowice Pyrzowice",
    "city": "Katowice",
    "country": "PL",
    "lat": 50.47
  },
  {
    "icao": "EPSC",
    "iata": "SZZ",
    "name": "Szczecin Goleniow",
    "city": "Szczecin",
    "country": "PL",
    "lat": 53.58
  },
  {
    "icao": "EPMO",
    "iata": "WMI",
    "name": "Warsaw Modlin",
    "city": "Warsaw",
    "country": "PL",
    "lat": 52.45
  },
  {
    "icao": "LKPR",
    "iata": "PRG",
    "name": "Prague Vaclav Havel",
    "city": "Prague",
    "country": "CZ",
    "lat": 50.1
  },
  {
    "icao": "LKTB",
    "iata": "BRQ",
    "name": "Brno Turany",
    "city": "Brno",
    "country": "CZ",
    "lat": 49.15
  },
  {
    "icao": "LKMT",
    "iata": "OSR",
    "name": "Ostrava Mosnov",
    "city": "Ostrava",
    "country": "CZ",
    "lat": 49.7
  },
  {
    "icao": "LHBP",
    "iata": "BUD",
    "name": "Budapest Liszt Ferenc",
    "city": "Budapest",
    "country": "HU",
    "lat": 47.44
  },
  {
    "icao": "LROP",
    "iata": "OTP",
    "name": "Bucharest Henri Coanda",
    "city": "Bucharest",
    "country": "RO",
    "lat": 44.57
  },
  {
    "icao": "LRCK",
    "iata": "CND",
    "name": "Constanta Mihail Kogalniceanu",
    "city": "Constanta",
    "country": "RO",
    "lat": 44.36
  },
  {
    "icao": "LRCL",
    "iata": "CLJ",
    "name": "Cluj-Napoca",
    "city": "Cluj-Napoca",
    "country": "RO",
    "lat": 46.79
  },
  {
    "icao": "LRTR",
    "iata": "TSR",
    "name": "Timisoara Traian Vuia",
    "city": "Timisoara",
    "country": "RO",
    "lat": 45.81
  },
  {
    "icao": "LZIB",
    "iata": "BTS",
    "name": "Bratislava M. R. Stefanik",
    "city": "Bratislava",
    "country": "SK",
    "lat": 48.17
  },
  {
    "icao": "LZKZ",
    "iata": "KSC",
    "name": "Kosice",
    "city": "Kosice",
    "country": "SK",
    "lat": 48.66
  },
  {
    "icao": "LGAV",
    "iata": "ATH",
    "name": "Athens Eleftherios Venizelos",
    "city": "Athens",
    "country": "GR",
    "lat": 37.94
  },
  {
    "icao": "LGTS",
    "iata": "SKG",
    "name": "Thessaloniki",
    "city": "Thessaloniki",
    "country": "GR",
    "lat": 40.52
  },
  {
    "icao": "LGIR",
    "iata": "HER",
    "name": "Heraklion Nikos Kazantzakis",
    "city": "Heraklion",
    "country": "GR",
    "lat": 35.34
  },
  {
    "icao": "LGKR",
    "iata": "CFU",
    "name": "Corfu Ioannis Kapodistrias",
    "city": "Corfu",
    "country": "GR",
    "lat": 39.6
  },
  {
    "icao": "LGRP",
    "iata": "RHO",
    "name": "Rhodes Diagoras",
    "city": "Rhodes",
    "country": "GR",
    "lat": 36.41
  },
  {
    "icao": "LGKO",
    "iata": "KGS",
    "name": "Kos",
    "city": "Kos",
    "country": "GR",
    "lat": 36.79
  },
  {
    "icao": "LGSA",
    "iata": "CHQ",
    "name": "Chania Daskalogiannis",
    "city": "Chania",
    "country": "GR",
    "lat": 35.53
  },
  {
    "icao": "LGMK",
    "iata": "JMK",
    "name": "Mykonos",
    "city": "Mykonos",
    "country": "GR",
    "lat": 37.44
  },
  {
    "icao": "LGSR",
    "iata": "JTR",
    "name": "Santorini",
    "city": "Santorini",
    "country": "GR",
    "lat": 36.4
  },
  {
    "icao": "LGZA",
    "iata": "ZTH",
    "name": "Zakynthos Dionysios Solomos",
    "city": "Zakynthos",
    "country": "GR",
    "lat": 37.75
  },
  {
    "icao": "LTFM",
    "iata": "IST",
    "name": "Istanbul",
    "city": "Istanbul",
    "country": "TR",
    "lat": 41.26
  },
  {
    "icao": "LTAI",
    "iata": "AYT",
    "name": "Antalya",
    "city": "Antalya",
    "country": "TR",
    "lat": 36.9
  },
  {
    "icao": "LTFJ",
    "iata": "SAW",
    "name": "Istanbul Sabiha Gokcen",
    "city": "Istanbul",
    "country": "TR",
    "lat": 40.9
  },
  {
    "icao": "LTAC",
    "iata": "ESB",
    "name": "Ankara Esenboga",
    "city": "Ankara",
    "country": "TR",
    "lat": 40.13
  },
  {
    "icao": "LTBJ",
    "iata": "ADB",
    "name": "Izmir Adnan Menderes",
    "city": "Izmir",
    "country": "TR",
    "lat": 38.29
  },
  {
    "icao": "LTBS",
    "iata": "DLM",
    "name": "Dalaman",
    "city": "Dalaman",
    "country": "TR",
    "lat": 36.71
  },
  {
    "icao": "LTFE",
    "iata": "BJV",
    "name": "Bodrum Milas",
    "city": "Bodrum",
    "country": "TR",
    "lat": 37.25
  },
  {
    "icao": "LTCE",
    "iata": "TZX",
    "name": "Trabzon",
    "city": "Trabzon",
    "country": "TR",
    "lat": 40.99
  },
  {
    "icao": "LPPT",
    "iata": "LIS",
    "name": "Lisbon Portela",
    "city": "Lisbon",
    "country": "PT",
    "lat": 38.77
  },
  {
    "icao": "LPPR",
    "iata": "OPO",
    "name": "Porto",
    "city": "Porto",
    "country": "PT",
    "lat": 41.24
  },
  {
    "icao": "LPFR",
    "iata": "FAO",
    "name": "Faro",
    "city": "Faro",
    "country": "PT",
    "lat": 37.01
  },
  {
    "icao": "LPMA",
    "iata": "FNC",
    "name": "Madeira Funchal",
    "city": "Funchal",
    "country": "PT",
    "lat": 32.69
  },
  {
    "icao": "LPPS",
    "iata": "PDL",
    "name": "Ponta Delgada",
    "city": "Ponta Delgada",
    "country": "PT",
    "lat": 37.74
  },
  {
    "icao": "EIDW",
    "iata": "DUB",
    "name": "Dublin",
    "city": "Dublin",
    "country": "IE",
    "lat": 53.42
  },
  {
    "icao": "EICK",
    "iata": "ORK",
    "name": "Cork",
    "city": "Cork",
    "country": "IE",
    "lat": 51.84
  },
  {
    "icao": "EINN",
    "iata": "SNN",
    "name": "Shannon",
    "city": "Shannon",
    "country": "IE",
    "lat": 52.7
  },
  {
    "icao": "EIKN",
    "iata": "NOC",
    "name": "Ireland West Knock",
    "city": "Knock",
    "country": "IE",
    "lat": 53.91
  },
  {
    "icao": "BIKF",
    "iata": "KEF",
    "name": "Keflavik",
    "city": "Reykjavik",
    "country": "IS",
    "lat": 63.99
  },
  {
    "icao": "BIRK",
    "iata": "RKV",
    "name": "Reykjavik Domestic",
    "city": "Reykjavik",
    "country": "IS",
    "lat": 64.13
  },
  {
    "icao": "LYBE",
    "iata": "BEG",
    "name": "Belgrade Nikola Tesla",
    "city": "Belgrade",
    "country": "RS",
    "lat": 44.82
  },
  {
    "icao": "LDZA",
    "iata": "ZAG",
    "name": "Zagreb",
    "city": "Zagreb",
    "country": "HR",
    "lat": 45.74
  },
  {
    "icao": "LDSP",
    "iata": "SPU",
    "name": "Split",
    "city": "Split",
    "country": "HR",
    "lat": 43.54
  },
  {
    "icao": "LDDU",
    "iata": "DBV",
    "name": "Dubrovnik",
    "city": "Dubrovnik",
    "country": "HR",
    "lat": 42.56
  },
  {
    "icao": "LDPL",
    "iata": "PUY",
    "name": "Pula",
    "city": "Pula",
    "country": "HR",
    "lat": 44.89
  },
  {
    "icao": "LDZD",
    "iata": "ZAD",
    "name": "Zadar",
    "city": "Zadar",
    "country": "HR",
    "lat": 44.1
  },
  {
    "icao": "LJLJ",
    "iata": "LJU",
    "name": "Ljubljana",
    "city": "Ljubljana",
    "country": "SI",
    "lat": 46.22
  },
  {
    "icao": "LQSA",
    "iata": "SJJ",
    "name": "Sarajevo",
    "city": "Sarajevo",
    "country": "BA",
    "lat": 43.82
  },
  {
    "icao": "LWSK",
    "iata": "SKP",
    "name": "Skopje",
    "city": "Skopje",
    "country": "MK",
    "lat": 41.96
  },
  {
    "icao": "LATI",
    "iata": "TIA",
    "name": "Tirana",
    "city": "Tirana",
    "country": "AL",
    "lat": 41.41
  },
  {
    "icao": "LBSF",
    "iata": "SOF",
    "name": "Sofia",
    "city": "Sofia",
    "country": "BG",
    "lat": 42.7
  },
  {
    "icao": "LBBG",
    "iata": "BOJ",
    "name": "Burgas",
    "city": "Burgas",
    "country": "BG",
    "lat": 42.57
  },
  {
    "icao": "LBWN",
    "iata": "VAR",
    "name": "Varna",
    "city": "Varna",
    "country": "BG",
    "lat": 43.23
  },
  {
    "icao": "UKBB",
    "iata": "KBP",
    "name": "Kyiv Boryspil",
    "city": "Kyiv",
    "country": "UA",
    "lat": 50.34
  },
  {
    "icao": "UKKK",
    "iata": "IEV",
    "name": "Kyiv Zhuliany",
    "city": "Kyiv",
    "country": "UA",
    "lat": 50.4
  },
  {
    "icao": "UKLL",
    "iata": "LWO",
    "name": "Lviv Danylo Halytskyi",
    "city": "Lviv",
    "country": "UA",
    "lat": 49.81
  },
  {
    "icao": "UKOO",
    "iata": "ODS",
    "name": "Odesa",
    "city": "Odesa",
    "country": "UA",
    "lat": 46.43
  },
  {
    "icao": "EVRA",
    "iata": "RIX",
    "name": "Riga",
    "city": "Riga",
    "country": "LV",
    "lat": 56.92
  },
  {
    "icao": "EYVI",
    "iata": "VNO",
    "name": "Vilnius",
    "city": "Vilnius",
    "country": "LT",
    "lat": 54.63
  },
  {
    "icao": "EYKA",
    "iata": "KUN",
    "name": "Kaunas",
    "city": "Kaunas",
    "country": "LT",
    "lat": 54.96
  },
  {
    "icao": "EETN",
    "iata": "TLL",
    "name": "Tallinn",
    "city": "Tallinn",
    "country": "EE",
    "lat": 59.41
  },
  {
    "icao": "LMML",
    "iata": "MLA",
    "name": "Malta Luqa",
    "city": "Malta",
    "country": "MT",
    "lat": 35.86
  },
  {
    "icao": "LCLK",
    "iata": "LCA",
    "name": "Larnaca",
    "city": "Larnaca",
    "country": "CY",
    "lat": 34.88
  },
  {
    "icao": "LCPH",
    "iata": "PFO",
    "name": "Paphos",
    "city": "Paphos",
    "country": "CY",
    "lat": 34.72
  },
  {
    "icao": "LXGB",
    "iata": "GIB",
    "name": "Gibraltar",
    "city": "Gibraltar",
    "country": "GI",
    "lat": 36.15
  },
  {
    "icao": "GCLA",
    "iata": "SPC",
    "name": "La Palma",
    "city": "Santa Cruz de La Palma",
    "country": "ES",
    "lat": 28.63
  },
  {
    "icao": "UKDR",
    "iata": "DNK",
    "name": "Dnipro",
    "city": "Dnipro",
    "country": "UA",
    "lat": 48.36
  },
  {
    "icao": "UUEE",
    "iata": "SVO",
    "name": "Moscow Sheremetyevo",
    "city": "Moscow",
    "country": "RU",
    "lat": 55.97
  },
  {
    "icao": "UUDD",
    "iata": "DME",
    "name": "Moscow Domodedovo",
    "city": "Moscow",
    "country": "RU",
    "lat": 55.41
  },
  {
    "icao": "UUWW",
    "iata": "VKO",
    "name": "Moscow Vnukovo",
    "city": "Moscow",
    "country": "RU",
    "lat": 55.6
  },
  {
    "icao": "ULLI",
    "iata": "LED",
    "name": "St Petersburg Pulkovo",
    "city": "St Petersburg",
    "country": "RU",
    "lat": 59.8
  },
  {
    "icao": "OMDB",
    "iata": "DXB",
    "name": "Dubai International",
    "city": "Dubai",
    "country": "AE",
    "lat": 25.25
  },
  {
    "icao": "OMSJ",
    "iata": "SHJ",
    "name": "Sharjah",
    "city": "Sharjah",
    "country": "AE",
    "lat": 25.33
  },
  {
    "icao": "OMAA",
    "iata": "AUH",
    "name": "Abu Dhabi",
    "city": "Abu Dhabi",
    "country": "AE",
    "lat": 24.43
  },
  {
    "icao": "OMDW",
    "iata": "DWC",
    "name": "Dubai Al Maktoum",
    "city": "Dubai",
    "country": "AE",
    "lat": 24.9
  },
  {
    "icao": "OTHH",
    "iata": "DOH",
    "name": "Hamad International",
    "city": "Doha",
    "country": "QA",
    "lat": 25.26
  },
  {
    "icao": "OEJN",
    "iata": "JED",
    "name": "King Abdulaziz",
    "city": "Jeddah",
    "country": "SA",
    "lat": 21.68
  },
  {
    "icao": "OERK",
    "iata": "RUH",
    "name": "King Khalid",
    "city": "Riyadh",
    "country": "SA",
    "lat": 24.96
  },
  {
    "icao": "OEDF",
    "iata": "DMM",
    "name": "King Fahd",
    "city": "Dammam",
    "country": "SA",
    "lat": 26.47
  },
  {
    "icao": "OEMA",
    "iata": "MED",
    "name": "Prince Mohammad Bin Abdulaziz",
    "city": "Medina",
    "country": "SA",
    "lat": 24.55
  },
  {
    "icao": "OBBI",
    "iata": "BAH",
    "name": "Bahrain International",
    "city": "Manama",
    "country": "BH",
    "lat": 26.27
  },
  {
    "icao": "OOMS",
    "iata": "MCT",
    "name": "Muscat",
    "city": "Muscat",
    "country": "OM",
    "lat": 23.59
  },
  {
    "icao": "OKBK",
    "iata": "KWI",
    "name": "Kuwait International",
    "city": "Kuwait City",
    "country": "KW",
    "lat": 29.23
  },
  {
    "icao": "OIIE",
    "iata": "IKA",
    "name": "Tehran Imam Khomeini",
    "city": "Tehran",
    "country": "IR",
    "lat": 35.42
  },
  {
    "icao": "OIII",
    "iata": "THR",
    "name": "Tehran Mehrabad",
    "city": "Tehran",
    "country": "IR",
    "lat": 35.69
  },
  {
    "icao": "OJAM",
    "iata": "AMM",
    "name": "Queen Alia",
    "city": "Amman",
    "country": "JO",
    "lat": 31.72
  },
  {
    "icao": "OLBA",
    "iata": "BEY",
    "name": "Beirut Rafic Hariri",
    "city": "Beirut",
    "country": "LB",
    "lat": 33.82
  },
  {
    "icao": "LLBG",
    "iata": "TLV",
    "name": "Ben Gurion",
    "city": "Tel Aviv",
    "country": "IL",
    "lat": 32.01
  },
  {
    "icao": "ORBI",
    "iata": "BGW",
    "name": "Baghdad International",
    "city": "Baghdad",
    "country": "IQ",
    "lat": 33.26
  },
  {
    "icao": "ORMM",
    "iata": "BSR",
    "name": "Basra International",
    "city": "Basra",
    "country": "IQ",
    "lat": 30.55
  },
  {
    "icao": "HECA",
    "iata": "CAI",
    "name": "Cairo International",
    "city": "Cairo",
    "country": "EG",
    "lat": 30.12
  },
  {
    "icao": "HEGN",
    "iata": "HRG",
    "name": "Hurghada",
    "city": "Hurghada",
    "country": "EG",
    "lat": 27.18
  },
  {
    "icao": "HESH",
    "iata": "SSH",
    "name": "Sharm El Sheikh",
    "city": "Sharm El Sheikh",
    "country": "EG",
    "lat": 27.98
  },
  {
    "icao": "HEMA",
    "iata": "RMF",
    "name": "Marsa Alam",
    "city": "Marsa Alam",
    "country": "EG",
    "lat": 25.56
  },
  {
    "icao": "HELX",
    "iata": "LXR",
    "name": "Luxor",
    "city": "Luxor",
    "country": "EG",
    "lat": 25.67
  },
  {
    "icao": "GMMN",
    "iata": "CMN",
    "name": "Mohammed V",
    "city": "Casablanca",
    "country": "MA",
    "lat": 33.37
  },
  {
    "icao": "GMME",
    "iata": "RBA",
    "name": "Rabat Sale",
    "city": "Rabat",
    "country": "MA",
    "lat": 34.05
  },
  {
    "icao": "GMMX",
    "iata": "RAK",
    "name": "Marrakech Menara",
    "city": "Marrakech",
    "country": "MA",
    "lat": 31.61
  },
  {
    "icao": "GMFF",
    "iata": "FEZ",
    "name": "Fes Saiss",
    "city": "Fes",
    "country": "MA",
    "lat": 33.93
  },
  {
    "icao": "GMTT",
    "iata": "TNG",
    "name": "Tangier Ibn Battouta",
    "city": "Tangier",
    "country": "MA",
    "lat": 35.73
  },
  {
    "icao": "DAAG",
    "iata": "ALG",
    "name": "Algiers Houari Boumediene",
    "city": "Algiers",
    "country": "DZ",
    "lat": 36.69
  },
  {
    "icao": "DTTA",
    "iata": "TUN",
    "name": "Tunis Carthage",
    "city": "Tunis",
    "country": "TN",
    "lat": 36.85
  },
  {
    "icao": "DTMB",
    "iata": "MIR",
    "name": "Monastir Habib Bourguiba",
    "city": "Monastir",
    "country": "TN",
    "lat": 35.76
  },
  {
    "icao": "DTTJ",
    "iata": "DJE",
    "name": "Djerba Zarzis",
    "city": "Djerba",
    "country": "TN",
    "lat": 33.88
  },
  {
    "icao": "HLLT",
    "iata": "TIP",
    "name": "Tripoli International",
    "city": "Tripoli",
    "country": "LY",
    "lat": 32.66
  },
  {
    "icao": "HKJK",
    "iata": "NBO",
    "name": "Jomo Kenyatta",
    "city": "Nairobi",
    "country": "KE",
    "lat": -1.32
  },
  {
    "icao": "HKMO",
    "iata": "MBA",
    "name": "Moi International",
    "city": "Mombasa",
    "country": "KE",
    "lat": -4.03
  },
  {
    "icao": "HTDA",
    "iata": "DAR",
    "name": "Julius Nyerere",
    "city": "Dar es Salaam",
    "country": "TZ",
    "lat": -6.88
  },
  {
    "icao": "HTZA",
    "iata": "ZNZ",
    "name": "Abeid Amani Karume",
    "city": "Zanzibar",
    "country": "TZ",
    "lat": -6.22
  },
  {
    "icao": "HTKJ",
    "iata": "JRO",
    "name": "Kilimanjaro",
    "city": "Arusha",
    "country": "TZ",
    "lat": -3.43
  },
  {
    "icao": "HAAB",
    "iata": "ADD",
    "name": "Addis Ababa Bole",
    "city": "Addis Ababa",
    "country": "ET",
    "lat": 8.98
  },
  {
    "icao": "FACT",
    "iata": "CPT",
    "name": "Cape Town",
    "city": "Cape Town",
    "country": "ZA",
    "lat": -33.97
  },
  {
    "icao": "FAOR",
    "iata": "JNB",
    "name": "OR Tambo",
    "city": "Johannesburg",
    "country": "ZA",
    "lat": -26.14
  },
  {
    "icao": "FALE",
    "iata": "DUR",
    "name": "King Shaka",
    "city": "Durban",
    "country": "ZA",
    "lat": -29.61
  },
  {
    "icao": "DNMM",
    "iata": "LOS",
    "name": "Murtala Muhammed",
    "city": "Lagos",
    "country": "NG",
    "lat": 6.58
  },
  {
    "icao": "DNAA",
    "iata": "ABV",
    "name": "Nnamdi Azikiwe",
    "city": "Abuja",
    "country": "NG",
    "lat": 9.01
  },
  {
    "icao": "DGAA",
    "iata": "ACC",
    "name": "Kotoka",
    "city": "Accra",
    "country": "GH",
    "lat": 5.6
  },
  {
    "icao": "DIAP",
    "iata": "ABJ",
    "name": "Felix Houphouet-Boigny",
    "city": "Abidjan",
    "country": "CI",
    "lat": 5.26
  },
  {
    "icao": "GOOY",
    "iata": "DSS",
    "name": "Blaise Diagne",
    "city": "Dakar",
    "country": "SN",
    "lat": 14.67
  },
  {
    "icao": "FMMI",
    "iata": "TNR",
    "name": "Ivato",
    "city": "Antananarivo",
    "country": "MG",
    "lat": -18.8
  },
  {
    "icao": "FIMP",
    "iata": "MRU",
    "name": "Sir Seewoosagur Ramgoolam",
    "city": "Mauritius",
    "country": "MU",
    "lat": -20.43
  },
  {
    "icao": "FWKI",
    "iata": "LLW",
    "name": "Kamuzu International",
    "city": "Lilongwe",
    "country": "MW",
    "lat": -13.79
  },
  {
    "icao": "FLKK",
    "iata": "LUN",
    "name": "Kenneth Kaunda",
    "city": "Lusaka",
    "country": "ZM",
    "lat": -15.33
  },
  {
    "icao": "FVHA",
    "iata": "HRE",
    "name": "Robert Gabriel Mugabe",
    "city": "Harare",
    "country": "ZW",
    "lat": -17.93
  },
  {
    "icao": "VHHH",
    "iata": "HKG",
    "name": "Hong Kong International",
    "city": "Hong Kong",
    "country": "HK",
    "lat": 22.31
  },
  {
    "icao": "WSSS",
    "iata": "SIN",
    "name": "Singapore Changi",
    "city": "Singapore",
    "country": "SG",
    "lat": 1.36
  },
  {
    "icao": "RJTT",
    "iata": "HND",
    "name": "Tokyo Haneda",
    "city": "Tokyo",
    "country": "JP",
    "lat": 35.55
  },
  {
    "icao": "RJAA",
    "iata": "NRT",
    "name": "Tokyo Narita",
    "city": "Tokyo",
    "country": "JP",
    "lat": 35.76
  },
  {
    "icao": "RJBB",
    "iata": "KIX",
    "name": "Osaka Kansai",
    "city": "Osaka",
    "country": "JP",
    "lat": 34.43
  },
  {
    "icao": "RJFF",
    "iata": "FUK",
    "name": "Fukuoka",
    "city": "Fukuoka",
    "country": "JP",
    "lat": 33.59
  },
  {
    "icao": "RJCC",
    "iata": "CTS",
    "name": "New Chitose",
    "city": "Sapporo",
    "country": "JP",
    "lat": 42.78
  },
  {
    "icao": "RJGG",
    "iata": "NGO",
    "name": "Chubu Centrair",
    "city": "Nagoya",
    "country": "JP",
    "lat": 34.86
  },
  {
    "icao": "RKSI",
    "iata": "ICN",
    "name": "Incheon International",
    "city": "Seoul",
    "country": "KR",
    "lat": 37.46
  },
  {
    "icao": "RKSS",
    "iata": "GMP",
    "name": "Gimpo International",
    "city": "Seoul",
    "country": "KR",
    "lat": 37.56
  },
  {
    "icao": "RKPK",
    "iata": "PUS",
    "name": "Gimhae",
    "city": "Busan",
    "country": "KR",
    "lat": 35.18
  },
  {
    "icao": "RKPC",
    "iata": "CJU",
    "name": "Jeju International",
    "city": "Jeju",
    "country": "KR",
    "lat": 33.51
  },
  {
    "icao": "ZBAA",
    "iata": "PEK",
    "name": "Beijing Capital",
    "city": "Beijing",
    "country": "CN",
    "lat": 40.08
  },
  {
    "icao": "ZBAD",
    "iata": "PKX",
    "name": "Beijing Daxing",
    "city": "Beijing",
    "country": "CN",
    "lat": 39.51
  },
  {
    "icao": "ZSPD",
    "iata": "PVG",
    "name": "Shanghai Pudong",
    "city": "Shanghai",
    "country": "CN",
    "lat": 31.14
  },
  {
    "icao": "ZSSS",
    "iata": "SHA",
    "name": "Shanghai Hongqiao",
    "city": "Shanghai",
    "country": "CN",
    "lat": 31.2
  },
  {
    "icao": "ZGGG",
    "iata": "CAN",
    "name": "Guangzhou Baiyun",
    "city": "Guangzhou",
    "country": "CN",
    "lat": 23.39
  },
  {
    "icao": "ZGSZ",
    "iata": "SZX",
    "name": "Shenzhen Bao'an",
    "city": "Shenzhen",
    "country": "CN",
    "lat": 22.64
  },
  {
    "icao": "ZUUU",
    "iata": "CTU",
    "name": "Chengdu Shuangliu",
    "city": "Chengdu",
    "country": "CN",
    "lat": 30.58
  },
  {
    "icao": "ZPPP",
    "iata": "KMG",
    "name": "Kunming Changshui",
    "city": "Kunming",
    "country": "CN",
    "lat": 24.99
  },
  {
    "icao": "ZUCK",
    "iata": "CKG",
    "name": "Chongqing Jiangbei",
    "city": "Chongqing",
    "country": "CN",
    "lat": 29.72
  },
  {
    "icao": "ZSHC",
    "iata": "HGH",
    "name": "Hangzhou Xiaoshan",
    "city": "Hangzhou",
    "country": "CN",
    "lat": 30.23
  },
  {
    "icao": "ZLXY",
    "iata": "XIY",
    "name": "Xi'an Xianyang",
    "city": "Xi'an",
    "country": "CN",
    "lat": 34.45
  },
  {
    "icao": "ZWWW",
    "iata": "URC",
    "name": "Urumqi Diwopu",
    "city": "Urumqi",
    "country": "CN",
    "lat": 43.91
  },
  {
    "icao": "RCTP",
    "iata": "TPE",
    "name": "Taiwan Taoyuan",
    "city": "Taipei",
    "country": "TW",
    "lat": 25.08
  },
  {
    "icao": "RCSS",
    "iata": "TSA",
    "name": "Taipei Songshan",
    "city": "Taipei",
    "country": "TW",
    "lat": 25.07
  },
  {
    "icao": "VTBS",
    "iata": "BKK",
    "name": "Suvarnabhumi",
    "city": "Bangkok",
    "country": "TH",
    "lat": 13.69
  },
  {
    "icao": "VTBD",
    "iata": "DMK",
    "name": "Don Mueang",
    "city": "Bangkok",
    "country": "TH",
    "lat": 13.91
  },
  {
    "icao": "VTSP",
    "iata": "HKT",
    "name": "Phuket",
    "city": "Phuket",
    "country": "TH",
    "lat": 8.11
  },
  {
    "icao": "VTCC",
    "iata": "CNX",
    "name": "Chiang Mai",
    "city": "Chiang Mai",
    "country": "TH",
    "lat": 18.77
  },
  {
    "icao": "VVNB",
    "iata": "HAN",
    "name": "Noi Bai",
    "city": "Hanoi",
    "country": "VN",
    "lat": 21.22
  },
  {
    "icao": "VVTS",
    "iata": "SGN",
    "name": "Tan Son Nhat",
    "city": "Ho Chi Minh City",
    "country": "VN",
    "lat": 10.82
  },
  {
    "icao": "VVDN",
    "iata": "DAD",
    "name": "Da Nang",
    "city": "Da Nang",
    "country": "VN",
    "lat": 16.04
  },
  {
    "icao": "WMKK",
    "iata": "KUL",
    "name": "Kuala Lumpur International",
    "city": "Kuala Lumpur",
    "country": "MY",
    "lat": 2.74
  },
  {
    "icao": "WMKP",
    "iata": "PEN",
    "name": "Penang International",
    "city": "Penang",
    "country": "MY",
    "lat": 5.3
  },
  {
    "icao": "WBKK",
    "iata": "BKI",
    "name": "Kota Kinabalu",
    "city": "Kota Kinabalu",
    "country": "MY",
    "lat": 5.94
  },
  {
    "icao": "WIII",
    "iata": "CGK",
    "name": "Soekarno-Hatta",
    "city": "Jakarta",
    "country": "ID",
    "lat": -6.13
  },
  {
    "icao": "WADD",
    "iata": "DPS",
    "name": "Ngurah Rai",
    "city": "Bali",
    "country": "ID",
    "lat": -8.75
  },
  {
    "icao": "WARR",
    "iata": "SUB",
    "name": "Juanda",
    "city": "Surabaya",
    "country": "ID",
    "lat": -7.38
  },
  {
    "icao": "RPLL",
    "iata": "MNL",
    "name": "Ninoy Aquino",
    "city": "Manila",
    "country": "PH",
    "lat": 14.51
  },
  {
    "icao": "RPMC",
    "iata": "CEB",
    "name": "Mactan-Cebu",
    "city": "Cebu",
    "country": "PH",
    "lat": 10.31
  },
  {
    "icao": "VIDP",
    "iata": "DEL",
    "name": "Indira Gandhi",
    "city": "New Delhi",
    "country": "IN",
    "lat": 28.57
  },
  {
    "icao": "VABB",
    "iata": "BOM",
    "name": "Chhatrapati Shivaji Maharaj",
    "city": "Mumbai",
    "country": "IN",
    "lat": 19.09
  },
  {
    "icao": "VOBL",
    "iata": "BLR",
    "name": "Kempegowda",
    "city": "Bangalore",
    "country": "IN",
    "lat": 13.2
  },
  {
    "icao": "VOMM",
    "iata": "MAA",
    "name": "Chennai",
    "city": "Chennai",
    "country": "IN",
    "lat": 12.99
  },
  {
    "icao": "VECC",
    "iata": "CCU",
    "name": "Netaji Subhas Chandra Bose",
    "city": "Kolkata",
    "country": "IN",
    "lat": 22.65
  },
  {
    "icao": "VOHS",
    "iata": "HYD",
    "name": "Rajiv Gandhi",
    "city": "Hyderabad",
    "country": "IN",
    "lat": 17.23
  },
  {
    "icao": "VOCI",
    "iata": "COK",
    "name": "Cochin",
    "city": "Kochi",
    "country": "IN",
    "lat": 10.15
  },
  {
    "icao": "VAAH",
    "iata": "AMD",
    "name": "Sardar Vallabhbhai Patel",
    "city": "Ahmedabad",
    "country": "IN",
    "lat": 23.07
  },
  {
    "icao": "VAGO",
    "iata": "GOI",
    "name": "Goa Dabolim",
    "city": "Goa",
    "country": "IN",
    "lat": 15.38
  },
  {
    "icao": "OPKC",
    "iata": "KHI",
    "name": "Jinnah International",
    "city": "Karachi",
    "country": "PK",
    "lat": 24.91
  },
  {
    "icao": "OPLA",
    "iata": "LHE",
    "name": "Allama Iqbal",
    "city": "Lahore",
    "country": "PK",
    "lat": 31.52
  },
  {
    "icao": "OPRN",
    "iata": "ISB",
    "name": "Islamabad International",
    "city": "Islamabad",
    "country": "PK",
    "lat": 33.62
  },
  {
    "icao": "VCBI",
    "iata": "CMB",
    "name": "Bandaranaike",
    "city": "Colombo",
    "country": "LK",
    "lat": 7.18
  },
  {
    "icao": "VRMM",
    "iata": "MLE",
    "name": "Velana International",
    "city": "Male",
    "country": "MV",
    "lat": 4.19
  },
  {
    "icao": "VNKT",
    "iata": "KTM",
    "name": "Tribhuvan",
    "city": "Kathmandu",
    "country": "NP",
    "lat": 27.7
  },
  {
    "icao": "VGHS",
    "iata": "DAC",
    "name": "Hazrat Shahjalal",
    "city": "Dhaka",
    "country": "BD",
    "lat": 23.84
  },
  {
    "icao": "UTTT",
    "iata": "TAS",
    "name": "Tashkent",
    "city": "Tashkent",
    "country": "UZ",
    "lat": 41.26
  },
  {
    "icao": "UAAA",
    "iata": "ALA",
    "name": "Almaty",
    "city": "Almaty",
    "country": "KZ",
    "lat": 43.35
  },
  {
    "icao": "UACC",
    "iata": "NQZ",
    "name": "Nursultan Nazarbayev",
    "city": "Astana",
    "country": "KZ",
    "lat": 51.02
  },
  {
    "icao": "UBBB",
    "iata": "GYD",
    "name": "Heydar Aliyev",
    "city": "Baku",
    "country": "AZ",
    "lat": 40.47
  },
  {
    "icao": "UGGG",
    "iata": "TBS",
    "name": "Tbilisi",
    "city": "Tbilisi",
    "country": "GE",
    "lat": 41.67
  },
  {
    "icao": "UDYZ",
    "iata": "EVN",
    "name": "Zvartnots",
    "city": "Yerevan",
    "country": "AM",
    "lat": 40.15
  },
  {
    "icao": "KJFK",
    "iata": "JFK",
    "name": "John F Kennedy",
    "city": "New York",
    "country": "US",
    "lat": 40.64
  },
  {
    "icao": "KLGA",
    "iata": "LGA",
    "name": "LaGuardia",
    "city": "New York",
    "country": "US",
    "lat": 40.78
  },
  {
    "icao": "KEWR",
    "iata": "EWR",
    "name": "Newark Liberty",
    "city": "Newark",
    "country": "US",
    "lat": 40.69
  },
  {
    "icao": "KLAX",
    "iata": "LAX",
    "name": "Los Angeles International",
    "city": "Los Angeles",
    "country": "US",
    "lat": 33.94
  },
  {
    "icao": "KORD",
    "iata": "ORD",
    "name": "O'Hare International",
    "city": "Chicago",
    "country": "US",
    "lat": 41.97
  },
  {
    "icao": "KATL",
    "iata": "ATL",
    "name": "Hartsfield-Jackson Atlanta",
    "city": "Atlanta",
    "country": "US",
    "lat": 33.64
  },
  {
    "icao": "KDFW",
    "iata": "DFW",
    "name": "Dallas Fort Worth",
    "city": "Dallas",
    "country": "US",
    "lat": 32.9
  },
  {
    "icao": "KDEN",
    "iata": "DEN",
    "name": "Denver International",
    "city": "Denver",
    "country": "US",
    "lat": 39.86
  },
  {
    "icao": "KSFO",
    "iata": "SFO",
    "name": "San Francisco International",
    "city": "San Francisco",
    "country": "US",
    "lat": 37.62
  },
  {
    "icao": "KSEA",
    "iata": "SEA",
    "name": "Seattle-Tacoma",
    "city": "Seattle",
    "country": "US",
    "lat": 47.45
  },
  {
    "icao": "KMIA",
    "iata": "MIA",
    "name": "Miami International",
    "city": "Miami",
    "country": "US",
    "lat": 25.8
  },
  {
    "icao": "KBOS",
    "iata": "BOS",
    "name": "Boston Logan",
    "city": "Boston",
    "country": "US",
    "lat": 42.36
  },
  {
    "icao": "KMSP",
    "iata": "MSP",
    "name": "Minneapolis-Saint Paul",
    "city": "Minneapolis",
    "country": "US",
    "lat": 44.88
  },
  {
    "icao": "KPHL",
    "iata": "PHL",
    "name": "Philadelphia International",
    "city": "Philadelphia",
    "country": "US",
    "lat": 39.87
  },
  {
    "icao": "KDTW",
    "iata": "DTW",
    "name": "Detroit Metropolitan",
    "city": "Detroit",
    "country": "US",
    "lat": 42.21
  },
  {
    "icao": "KFLL",
    "iata": "FLL",
    "name": "Fort Lauderdale Hollywood",
    "city": "Fort Lauderdale",
    "country": "US",
    "lat": 26.07
  },
  {
    "icao": "KIAH",
    "iata": "IAH",
    "name": "George Bush Intercontinental",
    "city": "Houston",
    "country": "US",
    "lat": 29.98
  },
  {
    "icao": "KHOU",
    "iata": "HOU",
    "name": "William P Hobby",
    "city": "Houston",
    "country": "US",
    "lat": 29.65
  },
  {
    "icao": "KMCO",
    "iata": "MCO",
    "name": "Orlando International",
    "city": "Orlando",
    "country": "US",
    "lat": 28.43
  },
  {
    "icao": "KPHX",
    "iata": "PHX",
    "name": "Phoenix Sky Harbor",
    "city": "Phoenix",
    "country": "US",
    "lat": 33.43
  },
  {
    "icao": "KSAN",
    "iata": "SAN",
    "name": "San Diego International",
    "city": "San Diego",
    "country": "US",
    "lat": 32.73
  },
  {
    "icao": "KTPA",
    "iata": "TPA",
    "name": "Tampa International",
    "city": "Tampa",
    "country": "US",
    "lat": 27.98
  },
  {
    "icao": "KSLC",
    "iata": "SLC",
    "name": "Salt Lake City",
    "city": "Salt Lake City",
    "country": "US",
    "lat": 40.79
  },
  {
    "icao": "KBWI",
    "iata": "BWI",
    "name": "Baltimore Washington",
    "city": "Baltimore",
    "country": "US",
    "lat": 39.18
  },
  {
    "icao": "KIAD",
    "iata": "IAD",
    "name": "Washington Dulles",
    "city": "Washington",
    "country": "US",
    "lat": 38.95
  },
  {
    "icao": "KDCA",
    "iata": "DCA",
    "name": "Ronald Reagan Washington",
    "city": "Washington",
    "country": "US",
    "lat": 38.85
  },
  {
    "icao": "KCLT",
    "iata": "CLT",
    "name": "Charlotte Douglas",
    "city": "Charlotte",
    "country": "US",
    "lat": 35.21
  },
  {
    "icao": "KPDX",
    "iata": "PDX",
    "name": "Portland International",
    "city": "Portland",
    "country": "US",
    "lat": 45.59
  },
  {
    "icao": "KSTL",
    "iata": "STL",
    "name": "St Louis Lambert",
    "city": "St Louis",
    "country": "US",
    "lat": 38.75
  },
  {
    "icao": "KPIT",
    "iata": "PIT",
    "name": "Pittsburgh International",
    "city": "Pittsburgh",
    "country": "US",
    "lat": 40.5
  },
  {
    "icao": "KIND",
    "iata": "IND",
    "name": "Indianapolis International",
    "city": "Indianapolis",
    "country": "US",
    "lat": 39.72
  },
  {
    "icao": "KCMH",
    "iata": "CMH",
    "name": "John Glenn Columbus",
    "city": "Columbus",
    "country": "US",
    "lat": 40.0
  },
  {
    "icao": "KRDU",
    "iata": "RDU",
    "name": "Raleigh Durham",
    "city": "Raleigh",
    "country": "US",
    "lat": 35.88
  },
  {
    "icao": "KAUS",
    "iata": "AUS",
    "name": "Austin-Bergstrom",
    "city": "Austin",
    "country": "US",
    "lat": 30.19
  },
  {
    "icao": "KSAT",
    "iata": "SAT",
    "name": "San Antonio International",
    "city": "San Antonio",
    "country": "US",
    "lat": 29.53
  },
  {
    "icao": "KLAS",
    "iata": "LAS",
    "name": "Harry Reid International",
    "city": "Las Vegas",
    "country": "US",
    "lat": 36.08
  },
  {
    "icao": "PANC",
    "iata": "ANC",
    "name": "Ted Stevens Anchorage",
    "city": "Anchorage",
    "country": "US",
    "lat": 61.17
  },
  {
    "icao": "PHNL",
    "iata": "HNL",
    "name": "Daniel K Inouye",
    "city": "Honolulu",
    "country": "US",
    "lat": 21.32
  },
  {
    "icao": "CYYZ",
    "iata": "YYZ",
    "name": "Toronto Pearson",
    "city": "Toronto",
    "country": "CA",
    "lat": 43.68
  },
  {
    "icao": "CYVR",
    "iata": "YVR",
    "name": "Vancouver International",
    "city": "Vancouver",
    "country": "CA",
    "lat": 49.19
  },
  {
    "icao": "CYUL",
    "iata": "YUL",
    "name": "Montreal Trudeau",
    "city": "Montreal",
    "country": "CA",
    "lat": 45.47
  },
  {
    "icao": "CYOW",
    "iata": "YOW",
    "name": "Ottawa Macdonald-Cartier",
    "city": "Ottawa",
    "country": "CA",
    "lat": 45.32
  },
  {
    "icao": "CYYC",
    "iata": "YYC",
    "name": "Calgary International",
    "city": "Calgary",
    "country": "CA",
    "lat": 51.11
  },
  {
    "icao": "CYEG",
    "iata": "YEG",
    "name": "Edmonton International",
    "city": "Edmonton",
    "country": "CA",
    "lat": 53.31
  },
  {
    "icao": "CYWG",
    "iata": "YWG",
    "name": "Winnipeg Richardson",
    "city": "Winnipeg",
    "country": "CA",
    "lat": 49.91
  },
  {
    "icao": "CYHZ",
    "iata": "YHZ",
    "name": "Halifax Stanfield",
    "city": "Halifax",
    "country": "CA",
    "lat": 44.88
  },
  {
    "icao": "MMMX",
    "iata": "MEX",
    "name": "Mexico City Benito Juarez",
    "city": "Mexico City",
    "country": "MX",
    "lat": 19.44
  },
  {
    "icao": "MMUN",
    "iata": "CUN",
    "name": "Cancun International",
    "city": "Cancun",
    "country": "MX",
    "lat": 21.04
  },
  {
    "icao": "MMGL",
    "iata": "GDL",
    "name": "Guadalajara Miguel Hidalgo",
    "city": "Guadalajara",
    "country": "MX",
    "lat": 20.52
  },
  {
    "icao": "MMMY",
    "iata": "MTY",
    "name": "Monterrey",
    "city": "Monterrey",
    "country": "MX",
    "lat": 25.78
  },
  {
    "icao": "MMTJ",
    "iata": "TIJ",
    "name": "Tijuana",
    "city": "Tijuana",
    "country": "MX",
    "lat": 32.54
  },
  {
    "icao": "MMPR",
    "iata": "PVR",
    "name": "Puerto Vallarta",
    "city": "Puerto Vallarta",
    "country": "MX",
    "lat": 20.68
  },
  {
    "icao": "MMMD",
    "iata": "MID",
    "name": "Merida Manuel Crescencio Rejon",
    "city": "Merida",
    "country": "MX",
    "lat": 20.94
  },
  {
    "icao": "MROC",
    "iata": "SJO",
    "name": "Juan Santamaria",
    "city": "San Jose",
    "country": "CR",
    "lat": 10.0
  },
  {
    "icao": "MPTO",
    "iata": "PTY",
    "name": "Tocumen International",
    "city": "Panama City",
    "country": "PA",
    "lat": 9.07
  },
  {
    "icao": "MKJP",
    "iata": "KIN",
    "name": "Norman Manley",
    "city": "Kingston",
    "country": "JM",
    "lat": 17.94
  },
  {
    "icao": "MUHA",
    "iata": "HAV",
    "name": "Jose Marti",
    "city": "Havana",
    "country": "CU",
    "lat": 22.99
  },
  {
    "icao": "MDSD",
    "iata": "SDQ",
    "name": "Las Americas",
    "city": "Santo Domingo",
    "country": "DO",
    "lat": 18.43
  },
  {
    "icao": "MDPC",
    "iata": "PUJ",
    "name": "Punta Cana",
    "city": "Punta Cana",
    "country": "DO",
    "lat": 18.57
  },
  {
    "icao": "TIST",
    "iata": "STT",
    "name": "Cyril E King",
    "city": "St Thomas",
    "country": "VI",
    "lat": 18.34
  },
  {
    "icao": "TLPC",
    "iata": "SLU",
    "name": "George F L Charles",
    "city": "Castries",
    "country": "LC",
    "lat": 14.02
  },
  {
    "icao": "TBPB",
    "iata": "BGI",
    "name": "Grantley Adams",
    "city": "Bridgetown",
    "country": "BB",
    "lat": 13.07
  },
  {
    "icao": "TNCM",
    "iata": "SXM",
    "name": "Princess Juliana",
    "city": "St Maarten",
    "country": "SX",
    "lat": 18.04
  },
  {
    "icao": "TNCA",
    "iata": "AUA",
    "name": "Queen Beatrix",
    "city": "Oranjestad",
    "country": "AW",
    "lat": 12.5
  },
  {
    "icao": "TNCC",
    "iata": "CUR",
    "name": "Hato International",
    "city": "Willemstad",
    "country": "CW",
    "lat": 12.17
  },
  {
    "icao": "TNCB",
    "iata": "BON",
    "name": "Flamingo International",
    "city": "Kralendijk",
    "country": "BQ",
    "lat": 12.13
  },
  {
    "icao": "SBGR",
    "iata": "GRU",
    "name": "Sao Paulo Guarulhos",
    "city": "Sao Paulo",
    "country": "BR",
    "lat": -23.43
  },
  {
    "icao": "SBGL",
    "iata": "GIG",
    "name": "Rio de Janeiro Galeao",
    "city": "Rio de Janeiro",
    "country": "BR",
    "lat": -22.81
  },
  {
    "icao": "SBBR",
    "iata": "BSB",
    "name": "Brasilia",
    "city": "Brasilia",
    "country": "BR",
    "lat": -15.87
  },
  {
    "icao": "SBKP",
    "iata": "VCP",
    "name": "Campinas Viracopos",
    "city": "Campinas",
    "country": "BR",
    "lat": -23.01
  },
  {
    "icao": "SBSP",
    "iata": "CGH",
    "name": "Sao Paulo Congonhas",
    "city": "Sao Paulo",
    "country": "BR",
    "lat": -23.63
  },
  {
    "icao": "SBSV",
    "iata": "SSA",
    "name": "Salvador Deputado Luis Eduardo Magalhaes",
    "city": "Salvador",
    "country": "BR",
    "lat": -12.91
  },
  {
    "icao": "SBRF",
    "iata": "REC",
    "name": "Recife Guararapes",
    "city": "Recife",
    "country": "BR",
    "lat": -8.13
  },
  {
    "icao": "SBPA",
    "iata": "POA",
    "name": "Porto Alegre Salgado Filho",
    "city": "Porto Alegre",
    "country": "BR",
    "lat": -29.99
  },
  {
    "icao": "SAEZ",
    "iata": "EZE",
    "name": "Buenos Aires Ezeiza",
    "city": "Buenos Aires",
    "country": "AR",
    "lat": -34.82
  },
  {
    "icao": "SABE",
    "iata": "AEP",
    "name": "Buenos Aires Aeroparque",
    "city": "Buenos Aires",
    "country": "AR",
    "lat": -34.56
  },
  {
    "icao": "SACO",
    "iata": "COR",
    "name": "Cordoba Ingeniero Ambrosio Taravella",
    "city": "Cordoba",
    "country": "AR",
    "lat": -31.32
  },
  {
    "icao": "SAME",
    "iata": "MDZ",
    "name": "Mendoza El Plumerillo",
    "city": "Mendoza",
    "country": "AR",
    "lat": -32.83
  },
  {
    "icao": "SCEL",
    "iata": "SCL",
    "name": "Santiago Arturo Merino Benitez",
    "city": "Santiago",
    "country": "CL",
    "lat": -33.39
  },
  {
    "icao": "SPJC",
    "iata": "LIM",
    "name": "Lima Jorge Chavez",
    "city": "Lima",
    "country": "PE",
    "lat": -12.02
  },
  {
    "icao": "SKBO",
    "iata": "BOG",
    "name": "Bogota El Dorado",
    "city": "Bogota",
    "country": "CO",
    "lat": 4.7
  },
  {
    "icao": "SKMR",
    "iata": "MDE",
    "name": "Medellin Jose Maria Cordova",
    "city": "Medellin",
    "country": "CO",
    "lat": 6.16
  },
  {
    "icao": "SKCG",
    "iata": "CTG",
    "name": "Cartagena Rafael Nunez",
    "city": "Cartagena",
    "country": "CO",
    "lat": 10.44
  },
  {
    "icao": "SKCL",
    "iata": "CLO",
    "name": "Cali Alfonso Bonilla Aragon",
    "city": "Cali",
    "country": "CO",
    "lat": 3.54
  },
  {
    "icao": "SEQM",
    "iata": "UIO",
    "name": "Quito Mariscal Sucre",
    "city": "Quito",
    "country": "EC",
    "lat": -0.13
  },
  {
    "icao": "SEGU",
    "iata": "GYE",
    "name": "Guayaquil Jose Joaquin de Olmedo",
    "city": "Guayaquil",
    "country": "EC",
    "lat": -2.16
  },
  {
    "icao": "SVMI",
    "iata": "CCS",
    "name": "Caracas Simon Bolivar",
    "city": "Caracas",
    "country": "VE",
    "lat": 10.6
  },
  {
    "icao": "SLLP",
    "iata": "LPB",
    "name": "La Paz El Alto",
    "city": "La Paz",
    "country": "BO",
    "lat": -16.51
  },
  {
    "icao": "SGAS",
    "iata": "ASU",
    "name": "Asuncion Silvio Pettirossi",
    "city": "Asuncion",
    "country": "PY",
    "lat": -25.24
  },
  {
    "icao": "SUAA",
    "iata": "MVD",
    "name": "Montevideo Carrasco",
    "city": "Montevideo",
    "country": "UY",
    "lat": -34.84
  },
  {
    "icao": "YSSY",
    "iata": "SYD",
    "name": "Sydney Kingsford Smith",
    "city": "Sydney",
    "country": "AU",
    "lat": -33.95
  },
  {
    "icao": "YMML",
    "iata": "MEL",
    "name": "Melbourne Tullamarine",
    "city": "Melbourne",
    "country": "AU",
    "lat": -37.67
  },
  {
    "icao": "YBBN",
    "iata": "BNE",
    "name": "Brisbane",
    "city": "Brisbane",
    "country": "AU",
    "lat": -27.38
  },
  {
    "icao": "YPPH",
    "iata": "PER",
    "name": "Perth",
    "city": "Perth",
    "country": "AU",
    "lat": -31.94
  },
  {
    "icao": "YPAD",
    "iata": "ADL",
    "name": "Adelaide",
    "city": "Adelaide",
    "country": "AU",
    "lat": -34.94
  },
  {
    "icao": "YSCB",
    "iata": "CBR",
    "name": "Canberra",
    "city": "Canberra",
    "country": "AU",
    "lat": -35.31
  },
  {
    "icao": "YPDN",
    "iata": "DRW",
    "name": "Darwin",
    "city": "Darwin",
    "country": "AU",
    "lat": -12.42
  },
  {
    "icao": "YMHB",
    "iata": "HBA",
    "name": "Hobart",
    "city": "Hobart",
    "country": "AU",
    "lat": -42.84
  },
  {
    "icao": "YBCG",
    "iata": "OOL",
    "name": "Gold Coast Coolangatta",
    "city": "Gold Coast",
    "country": "AU",
    "lat": -28.16
  },
  {
    "icao": "YBCS",
    "iata": "CNS",
    "name": "Cairns",
    "city": "Cairns",
    "country": "AU",
    "lat": -16.89
  },
  {
    "icao": "NZAA",
    "iata": "AKL",
    "name": "Auckland",
    "city": "Auckland",
    "country": "NZ",
    "lat": -37.01
  },
  {
    "icao": "NZWN",
    "iata": "WLG",
    "name": "Wellington",
    "city": "Wellington",
    "country": "NZ",
    "lat": -41.33
  },
  {
    "icao": "NZCH",
    "iata": "CHC",
    "name": "Christchurch",
    "city": "Christchurch",
    "country": "NZ",
    "lat": -43.49
  },
  {
    "icao": "NZQN",
    "iata": "ZQN",
    "name": "Queenstown",
    "city": "Queenstown",
    "country": "NZ",
    "lat": -45.02
  },
  {
    "icao": "NFFN",
    "iata": "NAN",
    "name": "Nadi International",
    "city": "Nadi",
    "country": "FJ",
    "lat": -17.75
  },
  {
    "icao": "WSSL",
    "iata": "XSP",
    "name": "Seletar Airport",
    "city": "Singapore",
    "country": "SG",
    "lat": 1.42
  },
  {
    "icao": "EHKD",
    "iata": "DHR",
    "name": "De Kooy",
    "city": "Den Helder",
    "country": "NL",
    "lat": 52.92
  },
  {
    "icao": "EHWO",
    "iata": "WOE",
    "name": "Woensdrecht",
    "city": "Woensdrecht",
    "country": "NL",
    "lat": 51.45
  },
  {
    "icao": "EDJA",
    "iata": "FMM",
    "name": "Memmingen Allgau",
    "city": "Memmingen",
    "country": "DE",
    "lat": 47.99
  },
  {
    "icao": "EDNY",
    "iata": "FDH",
    "name": "Friedrichshafen",
    "city": "Friedrichshafen",
    "country": "DE",
    "lat": 47.67
  },
  {
    "icao": "EDQM",
    "iata": "HOQ",
    "name": "Hof Plauen",
    "city": "Hof",
    "country": "DE",
    "lat": 50.29
  },
  {
    "icao": "ETOU",
    "iata": "GHF",
    "name": "Giebelstadt",
    "city": "Giebelstadt",
    "country": "DE",
    "lat": 49.65
  },
  {
    "icao": "EGNJ",
    "iata": "HUY",
    "name": "Humberside",
    "city": "Grimsby",
    "country": "GB",
    "lat": 53.57
  },
  {
    "icao": "EGAE",
    "iata": "LDY",
    "name": "City of Derry",
    "city": "Derry",
    "country": "GB",
    "lat": 55.04
  },
  {
    "icao": "EGAC",
    "iata": "BHD",
    "name": "Belfast City George Best",
    "city": "Belfast",
    "country": "GB",
    "lat": 54.62
  },
  {
    "icao": "EGAA",
    "iata": "BFS",
    "name": "Belfast International",
    "city": "Belfast",
    "country": "GB",
    "lat": 54.66
  },
  {
    "icao": "EGPA",
    "iata": "KOI",
    "name": "Kirkwall",
    "city": "Kirkwall",
    "country": "GB",
    "lat": 58.96
  },
  {
    "icao": "EGPE",
    "iata": "INV",
    "name": "Inverness",
    "city": "Inverness",
    "country": "GB",
    "lat": 57.54
  },
  {
    "icao": "LFKJ",
    "iata": "AJA",
    "name": "Ajaccio Napoleon Bonaparte",
    "city": "Ajaccio",
    "country": "FR",
    "lat": 41.92
  },
  {
    "icao": "LFKB",
    "iata": "BIA",
    "name": "Bastia Poretta",
    "city": "Bastia",
    "country": "FR",
    "lat": 42.55
  },
  {
    "icao": "LFLB",
    "iata": "CMF",
    "name": "Chambery Savoie",
    "city": "Chambery",
    "country": "FR",
    "lat": 45.64
  },
  {
    "icao": "LFMK",
    "iata": "CCF",
    "name": "Carcassonne",
    "city": "Carcassonne",
    "country": "FR",
    "lat": 43.22
  },
  {
    "icao": "GCGM",
    "iata": "GMZ",
    "name": "La Gomera",
    "city": "La Gomera",
    "country": "ES",
    "lat": 28.03
  },
  {
    "icao": "LEMI",
    "iata": "RMU",
    "name": "Murcia Corvera",
    "city": "Murcia",
    "country": "ES",
    "lat": 37.8
  },
  {
    "icao": "LEXJ",
    "iata": "SDR",
    "name": "Santander",
    "city": "Santander",
    "country": "ES",
    "lat": 43.43
  },
  {
    "icao": "LEAS",
    "iata": "OVD",
    "name": "Asturias",
    "city": "Oviedo",
    "country": "ES",
    "lat": 43.56
  },
  {
    "icao": "LEVX",
    "iata": "VGO",
    "name": "Vigo Peinador",
    "city": "Vigo",
    "country": "ES",
    "lat": 42.23
  },
  {
    "icao": "LICR",
    "iata": "REG",
    "name": "Reggio Calabria",
    "city": "Reggio Calabria",
    "country": "IT",
    "lat": 38.07
  },
  {
    "icao": "LIEO",
    "iata": "OLB",
    "name": "Olbia Costa Smeralda",
    "city": "Olbia",
    "country": "IT",
    "lat": 40.9
  },
  {
    "icao": "LIEE",
    "iata": "CAG",
    "name": "Cagliari Elmas",
    "city": "Cagliari",
    "country": "IT",
    "lat": 39.25
  },
  {
    "icao": "LIRG",
    "iata": "GRS",
    "name": "Grosseto",
    "city": "Grosseto",
    "country": "IT",
    "lat": 42.76
  },
  {
    "icao": "LIPH",
    "iata": "TSF",
    "name": "Treviso",
    "city": "Treviso",
    "country": "IT",
    "lat": 45.65
  },
  {
    "icao": "LIPO",
    "iata": "BZO",
    "name": "Bolzano",
    "city": "Bolzano",
    "country": "IT",
    "lat": 46.46
  },
  {
    "icao": "LGSM",
    "iata": "SMI",
    "name": "Samos",
    "city": "Samos",
    "country": "GR",
    "lat": 37.69
  },
  {
    "icao": "LGKF",
    "iata": "EFL",
    "name": "Kefalonia",
    "city": "Kefalonia",
    "country": "GR",
    "lat": 38.12
  },
  {
    "icao": "LGSK",
    "iata": "JSI",
    "name": "Skiathos",
    "city": "Skiathos",
    "country": "GR",
    "lat": 39.18
  },
  {
    "icao": "LTCG",
    "iata": "VAN",
    "name": "Van Ferit Melen",
    "city": "Van",
    "country": "TR",
    "lat": 38.47
  },
  {
    "icao": "LTCJ",
    "iata": "GZT",
    "name": "Gaziantep Oguzeli",
    "city": "Gaziantep",
    "country": "TR",
    "lat": 36.95
  },
  {
    "icao": "LTAN",
    "iata": "KYA",
    "name": "Konya",
    "city": "Konya",
    "country": "TR",
    "lat": 37.98
  },
  {
    "icao": "LTAU",
    "iata": "ASR",
    "name": "Kayseri Erkilet",
    "city": "Kayseri",
    "country": "TR",
    "lat": 38.77
  },
  {
    "icao": "ESPA",
    "iata": "LLA",
    "name": "Lulea Kallax",
    "city": "Lulea",
    "country": "SE",
    "lat": 65.54
  },
  {
    "icao": "ESNU",
    "iata": "UME",
    "name": "Umea",
    "city": "Umea",
    "country": "SE",
    "lat": 63.79
  },
  {
    "icao": "ESNK",
    "iata": "KRN",
    "name": "Kiruna",
    "city": "Kiruna",
    "country": "SE",
    "lat": 67.82
  },
  {
    "icao": "ESMQ",
    "iata": "KLR",
    "name": "Kalmar",
    "city": "Kalmar",
    "country": "SE",
    "lat": 56.69
  },
  {
    "icao": "ESMT",
    "iata": "HAD",
    "name": "Halmstad",
    "city": "Halmstad",
    "country": "SE",
    "lat": 56.69
  },
  {
    "icao": "ENEV",
    "iata": "EVE",
    "name": "Harstad Narvik Evenes",
    "city": "Evenes",
    "country": "NO",
    "lat": 68.49
  },
  {
    "icao": "ENML",
    "iata": "MOL",
    "name": "Molde Aro",
    "city": "Molde",
    "country": "NO",
    "lat": 62.74
  },
  {
    "icao": "ENKR",
    "iata": "KKN",
    "name": "Kirkenes Hoybuktmoen",
    "city": "Kirkenes",
    "country": "NO",
    "lat": 69.73
  },
  {
    "icao": "ENAT",
    "iata": "ALF",
    "name": "Alta",
    "city": "Alta",
    "country": "NO",
    "lat": 69.98
  },
  {
    "icao": "ENTO",
    "iata": "TRF",
    "name": "Sandefjord Torp",
    "city": "Sandefjord",
    "country": "NO",
    "lat": 59.19
  },
  {
    "icao": "EKAH",
    "iata": "AAR",
    "name": "Aarhus",
    "city": "Aarhus",
    "country": "DK",
    "lat": 56.3
  },
  {
    "icao": "EKRN",
    "iata": "RNN",
    "name": "Bornholm",
    "city": "Ronne",
    "country": "DK",
    "lat": 55.06
  },
  {
    "icao": "EFIV",
    "iata": "IVL",
    "name": "Ivalo",
    "city": "Ivalo",
    "country": "FI",
    "lat": 68.61
  },
  {
    "icao": "EFKT",
    "iata": "KTT",
    "name": "Kittila",
    "city": "Kittila",
    "country": "FI",
    "lat": 67.7
  },
  {
    "icao": "EFKU",
    "iata": "KUO",
    "name": "Kuopio",
    "city": "Kuopio",
    "country": "FI",
    "lat": 63.01
  },
  {
    "icao": "EFLP",
    "iata": "LPP",
    "name": "Lappeenranta",
    "city": "Lappeenranta",
    "country": "FI",
    "lat": 61.04
  },
  {
    "icao": "LRBS",
    "iata": "BBU",
    "name": "Bucharest Baneasa",
    "city": "Bucharest",
    "country": "RO",
    "lat": 44.5
  },
  {
    "icao": "LRIA",
    "iata": "IAS",
    "name": "Iasi",
    "city": "Iasi",
    "country": "RO",
    "lat": 47.18
  },
  {
    "icao": "LWOH",
    "iata": "OHD",
    "name": "Ohrid St Paul the Apostle",
    "city": "Ohrid",
    "country": "MK",
    "lat": 41.18
  },
  {
    "icao": "LYNI",
    "iata": "INI",
    "name": "Nis Constantine the Great",
    "city": "Nis",
    "country": "RS",
    "lat": 43.34
  },
  {
    "icao": "LRCV",
    "iata": "CRA",
    "name": "Craiova",
    "city": "Craiova",
    "country": "RO",
    "lat": 44.32
  },
  {
    "icao": "LRSB",
    "iata": "SBZ",
    "name": "Sibiu",
    "city": "Sibiu",
    "country": "RO",
    "lat": 45.79
  },
  {
    "icao": "UKHH",
    "iata": "HRK",
    "name": "Kharkiv",
    "city": "Kharkiv",
    "country": "UA",
    "lat": 49.92
  },
  {
    "icao": "UMMS",
    "iata": "MSQ",
    "name": "Minsk National",
    "city": "Minsk",
    "country": "BY",
    "lat": 53.88
  },
  {
    "icao": "UGSS",
    "iata": "BUS",
    "name": "Batumi",
    "city": "Batumi",
    "country": "GE",
    "lat": 41.61
  },
  {
    "icao": "UGKO",
    "iata": "KUT",
    "name": "Kutaisi David the Builder",
    "city": "Kutaisi",
    "country": "GE",
    "lat": 42.18
  },
  {
    "icao": "LTCN",
    "iata": "NOP",
    "name": "Sinop",
    "city": "Sinop",
    "country": "TR",
    "lat": 42.02
  },
  {
    "icao": "OEAB",
    "iata": "AHB",
    "name": "Abha",
    "city": "Abha",
    "country": "SA",
    "lat": 18.24
  },
  {
    "icao": "OETB",
    "iata": "TUU",
    "name": "Tabuk",
    "city": "Tabuk",
    "country": "SA",
    "lat": 28.37
  },
  {
    "icao": "OMRK",
    "iata": "RKT",
    "name": "Ras Al Khaimah",
    "city": "Ras Al Khaimah",
    "country": "AE",
    "lat": 25.61
  },
  {
    "icao": "OISS",
    "iata": "SYZ",
    "name": "Shiraz",
    "city": "Shiraz",
    "country": "IR",
    "lat": 29.54
  },
  {
    "icao": "OIFM",
    "iata": "IFN",
    "name": "Isfahan",
    "city": "Isfahan",
    "country": "IR",
    "lat": 32.75
  },
  {
    "icao": "OIMM",
    "iata": "MHD",
    "name": "Mashhad",
    "city": "Mashhad",
    "country": "IR",
    "lat": 36.24
  },
  {
    "icao": "OIBB",
    "iata": "BUZ",
    "name": "Bushehr",
    "city": "Bushehr",
    "country": "IR",
    "lat": 28.94
  },
  {
    "icao": "OIKB",
    "iata": "BND",
    "name": "Bandar Abbas",
    "city": "Bandar Abbas",
    "country": "IR",
    "lat": 27.22
  },
  {
    "icao": "OPIS",
    "iata": "ISB",
    "name": "Islamabad International",
    "city": "Islamabad",
    "country": "PK",
    "lat": 33.62
  },
  {
    "icao": "OPPS",
    "iata": "PEW",
    "name": "Bacha Khan Peshawar",
    "city": "Peshawar",
    "country": "PK",
    "lat": 33.99
  },
  {
    "icao": "OPQT",
    "iata": "UET",
    "name": "Quetta",
    "city": "Quetta",
    "country": "PK",
    "lat": 30.25
  },
  {
    "icao": "VIAG",
    "iata": "AGR",
    "name": "Agra",
    "city": "Agra",
    "country": "IN",
    "lat": 27.16
  },
  {
    "icao": "VAJB",
    "iata": "JLR",
    "name": "Jabalpur",
    "city": "Jabalpur",
    "country": "IN",
    "lat": 23.18
  },
  {
    "icao": "VOTP",
    "iata": "TRV",
    "name": "Trivandrum",
    "city": "Thiruvananthapuram",
    "country": "IN",
    "lat": 8.48
  },
  {
    "icao": "VOBG",
    "iata": "IXE",
    "name": "Mangalore",
    "city": "Mangalore",
    "country": "IN",
    "lat": 12.96
  },
  {
    "icao": "VARP",
    "iata": "RAJ",
    "name": "Rajkot",
    "city": "Rajkot",
    "country": "IN",
    "lat": 22.31
  },
  {
    "icao": "VASU",
    "iata": "STV",
    "name": "Surat",
    "city": "Surat",
    "country": "IN",
    "lat": 21.11
  },
  {
    "icao": "VIJS",
    "iata": "IXJ",
    "name": "Jammu",
    "city": "Jammu",
    "country": "IN",
    "lat": 32.69
  },
  {
    "icao": "VILK",
    "iata": "LKO",
    "name": "Lucknow Chaudhary Charan Singh",
    "city": "Lucknow",
    "country": "IN",
    "lat": 26.76
  },
  {
    "icao": "VAPO",
    "iata": "PNQ",
    "name": "Pune",
    "city": "Pune",
    "country": "IN",
    "lat": 18.58
  },
  {
    "icao": "VANP",
    "iata": "NAG",
    "name": "Nagpur",
    "city": "Nagpur",
    "country": "IN",
    "lat": 21.09
  },
  {
    "icao": "VEJP",
    "iata": "JAI",
    "name": "Jaipur",
    "city": "Jaipur",
    "country": "IN",
    "lat": 26.82
  },
  {
    "icao": "ZBTJ",
    "iata": "TSN",
    "name": "Tianjin Binhai",
    "city": "Tianjin",
    "country": "CN",
    "lat": 39.12
  },
  {
    "icao": "ZHCC",
    "iata": "CGO",
    "name": "Zhengzhou Xinzheng",
    "city": "Zhengzhou",
    "country": "CN",
    "lat": 34.52
  },
  {
    "icao": "ZJHK",
    "iata": "HAK",
    "name": "Haikou Meilan",
    "city": "Haikou",
    "country": "CN",
    "lat": 19.93
  },
  {
    "icao": "ZJSY",
    "iata": "SYX",
    "name": "Sanya Phoenix",
    "city": "Sanya",
    "country": "CN",
    "lat": 18.3
  },
  {
    "icao": "ZSAM",
    "iata": "XMN",
    "name": "Xiamen Gaoqi",
    "city": "Xiamen",
    "country": "CN",
    "lat": 24.54
  },
  {
    "icao": "ZSNJ",
    "iata": "NKG",
    "name": "Nanjing Lukou",
    "city": "Nanjing",
    "country": "CN",
    "lat": 31.74
  },
  {
    "icao": "ZUGY",
    "iata": "KWE",
    "name": "Guiyang Longdongbao",
    "city": "Guiyang",
    "country": "CN",
    "lat": 26.54
  },
  {
    "icao": "ZLLL",
    "iata": "LHW",
    "name": "Lanzhou Zhongchuan",
    "city": "Lanzhou",
    "country": "CN",
    "lat": 36.52
  },
  {
    "icao": "ZSFZ",
    "iata": "FOC",
    "name": "Fuzhou Changle",
    "city": "Fuzhou",
    "country": "CN",
    "lat": 25.94
  },
  {
    "icao": "ZSWZ",
    "iata": "WNZ",
    "name": "Wenzhou Longwan",
    "city": "Wenzhou",
    "country": "CN",
    "lat": 27.91
  },
  {
    "icao": "ZSDL",
    "iata": "DLC",
    "name": "Dalian Zhoushuizi",
    "city": "Dalian",
    "country": "CN",
    "lat": 38.97
  },
  {
    "icao": "ZYTL",
    "iata": "DLC",
    "name": "Dalian",
    "city": "Dalian",
    "country": "CN",
    "lat": 38.97
  },
  {
    "icao": "ZYTX",
    "iata": "SHE",
    "name": "Shenyang Taoxian",
    "city": "Shenyang",
    "country": "CN",
    "lat": 41.64
  },
  {
    "icao": "ZYCC",
    "iata": "CGQ",
    "name": "Changchun Longjia",
    "city": "Changchun",
    "country": "CN",
    "lat": 43.9
  },
  {
    "icao": "ZYHB",
    "iata": "HRB",
    "name": "Harbin Taiping",
    "city": "Harbin",
    "country": "CN",
    "lat": 45.62
  },
  {
    "icao": "RJOO",
    "iata": "ITM",
    "name": "Osaka Itami",
    "city": "Osaka",
    "country": "JP",
    "lat": 34.79
  },
  {
    "icao": "RJSS",
    "iata": "SDJ",
    "name": "Sendai",
    "city": "Sendai",
    "country": "JP",
    "lat": 38.14
  },
  {
    "icao": "RJSN",
    "iata": "KIJ",
    "name": "Niigata",
    "city": "Niigata",
    "country": "JP",
    "lat": 37.96
  },
  {
    "icao": "ROAH",
    "iata": "OKA",
    "name": "Naha Okinawa",
    "city": "Naha",
    "country": "JP",
    "lat": 26.2
  },
  {
    "icao": "RJFT",
    "iata": "KMJ",
    "name": "Kumamoto",
    "city": "Kumamoto",
    "country": "JP",
    "lat": 32.84
  },
  {
    "icao": "RJFK",
    "iata": "KOJ",
    "name": "Kagoshima",
    "city": "Kagoshima",
    "country": "JP",
    "lat": 31.8
  },
  {
    "icao": "RJOH",
    "iata": "YGJ",
    "name": "Yonago Kitaro",
    "city": "Yonago",
    "country": "JP",
    "lat": 35.49
  },
  {
    "icao": "RJFM",
    "iata": "MYJ",
    "name": "Matsuyama",
    "city": "Matsuyama",
    "country": "JP",
    "lat": 33.83
  },
  {
    "icao": "RJBE",
    "iata": "UKB",
    "name": "Kobe",
    "city": "Kobe",
    "country": "JP",
    "lat": 34.63
  },
  {
    "icao": "RKTN",
    "iata": "TAE",
    "name": "Daegu",
    "city": "Daegu",
    "country": "KR",
    "lat": 35.89
  },
  {
    "icao": "RCMQ",
    "iata": "RMQ",
    "name": "Taichung",
    "city": "Taichung",
    "country": "TW",
    "lat": 24.26
  },
  {
    "icao": "RCKH",
    "iata": "KHH",
    "name": "Kaohsiung",
    "city": "Kaohsiung",
    "country": "TW",
    "lat": 22.58
  },
  {
    "icao": "VTUK",
    "iata": "KKC",
    "name": "Khon Kaen",
    "city": "Khon Kaen",
    "country": "TH",
    "lat": 16.47
  },
  {
    "icao": "VTSS",
    "iata": "HDY",
    "name": "Hat Yai",
    "city": "Hat Yai",
    "country": "TH",
    "lat": 6.93
  },
  {
    "icao": "VTSM",
    "iata": "USM",
    "name": "Koh Samui",
    "city": "Koh Samui",
    "country": "TH",
    "lat": 9.55
  },
  {
    "icao": "VTPM",
    "iata": "MAQ",
    "name": "Mae Sot",
    "city": "Mae Sot",
    "country": "TH",
    "lat": 16.7
  },
  {
    "icao": "VVCR",
    "iata": "CXR",
    "name": "Cam Ranh",
    "city": "Nha Trang",
    "country": "VN",
    "lat": 11.99
  },
  {
    "icao": "VVPQ",
    "iata": "PQC",
    "name": "Phu Quoc",
    "city": "Phu Quoc",
    "country": "VN",
    "lat": 10.23
  },
  {
    "icao": "VVDL",
    "iata": "DLI",
    "name": "Lien Khuong",
    "city": "Da Lat",
    "country": "VN",
    "lat": 11.75
  },
  {
    "icao": "WMSA",
    "iata": "SZB",
    "name": "Sultan Abdul Aziz Shah",
    "city": "Kuala Lumpur",
    "country": "MY",
    "lat": 3.13
  },
  {
    "icao": "WMKL",
    "iata": "LGK",
    "name": "Langkawi",
    "city": "Langkawi",
    "country": "MY",
    "lat": 6.33
  },
  {
    "icao": "WBGG",
    "iata": "KCH",
    "name": "Kuching",
    "city": "Kuching",
    "country": "MY",
    "lat": 1.48
  },
  {
    "icao": "WIDD",
    "iata": "BPN",
    "name": "Balikpapan Sultan Aji Muhammad Sulaiman",
    "city": "Balikpapan",
    "country": "ID",
    "lat": -1.27
  },
  {
    "icao": "WADY",
    "iata": "JOG",
    "name": "Yogyakarta Adisutjipto",
    "city": "Yogyakarta",
    "country": "ID",
    "lat": -7.79
  },
  {
    "icao": "WIMM",
    "iata": "KNO",
    "name": "Kualanamu",
    "city": "Medan",
    "country": "ID",
    "lat": 3.56
  },
  {
    "icao": "WAAA",
    "iata": "UPG",
    "name": "Makassar Sultan Hasanuddin",
    "city": "Makassar",
    "country": "ID",
    "lat": -5.06
  },
  {
    "icao": "WICC",
    "iata": "BDO",
    "name": "Husein Sastranegara",
    "city": "Bandung",
    "country": "ID",
    "lat": -6.9
  },
  {
    "icao": "WALL",
    "iata": "BPN",
    "name": "Sepinggan",
    "city": "Balikpapan",
    "country": "ID",
    "lat": -1.27
  },
  {
    "icao": "RPMD",
    "iata": "DVO",
    "name": "Francisco Bangoy",
    "city": "Davao",
    "country": "PH",
    "lat": 7.13
  },
  {
    "icao": "RPVI",
    "iata": "ILO",
    "name": "Iloilo",
    "city": "Iloilo",
    "country": "PH",
    "lat": 10.71
  },
  {
    "icao": "RPVP",
    "iata": "PPS",
    "name": "Puerto Princesa",
    "city": "Puerto Princesa",
    "country": "PH",
    "lat": 9.74
  },
  {
    "icao": "VYYY",
    "iata": "RGN",
    "name": "Yangon",
    "city": "Yangon",
    "country": "MM",
    "lat": 16.91
  },
  {
    "icao": "VYMD",
    "iata": "MDL",
    "name": "Mandalay",
    "city": "Mandalay",
    "country": "MM",
    "lat": 21.7
  },
  {
    "icao": "VLLV",
    "iata": "VTE",
    "name": "Wattay",
    "city": "Vientiane",
    "country": "LA",
    "lat": 17.99
  },
  {
    "icao": "VLLB",
    "iata": "LPQ",
    "name": "Luang Prabang",
    "city": "Luang Prabang",
    "country": "LA",
    "lat": 19.9
  },
  {
    "icao": "VDPP",
    "iata": "PNH",
    "name": "Phnom Penh",
    "city": "Phnom Penh",
    "country": "KH",
    "lat": 11.55
  },
  {
    "icao": "VDSR",
    "iata": "REP",
    "name": "Siem Reap Angkor",
    "city": "Siem Reap",
    "country": "KH",
    "lat": 13.41
  },
  {
    "icao": "WMKJ",
    "iata": "JHB",
    "name": "Senai",
    "city": "Johor Bahru",
    "country": "MY",
    "lat": 1.64
  },
  {
    "icao": "UTAT",
    "iata": "DYU",
    "name": "Dushanbe",
    "city": "Dushanbe",
    "country": "TJ",
    "lat": 38.54
  },
  {
    "icao": "UCFM",
    "iata": "FRU",
    "name": "Manas",
    "city": "Bishkek",
    "country": "KG",
    "lat": 43.06
  },
  {
    "icao": "UTAM",
    "iata": "MYP",
    "name": "Mary",
    "city": "Mary",
    "country": "TM",
    "lat": 37.62
  },
  {
    "icao": "UTAV",
    "iata": "ASB",
    "name": "Ashgabat",
    "city": "Ashgabat",
    "country": "TM",
    "lat": 37.99
  },
  {
    "icao": "UADD",
    "iata": "AKX",
    "name": "Aktobe",
    "city": "Aktobe",
    "country": "KZ",
    "lat": 50.25
  },
  {
    "icao": "UAKK",
    "iata": "KGF",
    "name": "Karaganda",
    "city": "Karaganda",
    "country": "KZ",
    "lat": 49.67
  },
  {
    "icao": "UAOO",
    "iata": "CIT",
    "name": "Shymkent",
    "city": "Shymkent",
    "country": "KZ",
    "lat": 42.36
  },
  {
    "icao": "OOSA",
    "iata": "SLL",
    "name": "Salalah",
    "city": "Salalah",
    "country": "OM",
    "lat": 17.04
  },
  {
    "icao": "VRMG",
    "iata": "GAN",
    "name": "Gan Island",
    "city": "Addu City",
    "country": "MV",
    "lat": -0.69
  },
  {
    "icao": "HDAM",
    "iata": "JIB",
    "name": "Djibouti Ambouli",
    "city": "Djibouti",
    "country": "DJ",
    "lat": 11.55
  },
  {
    "icao": "HCMM",
    "iata": "MGQ",
    "name": "Aden Abdulle International",
    "city": "Mogadishu",
    "country": "SO",
    "lat": 2.01
  },
  {
    "icao": "HUEN",
    "iata": "EBB",
    "name": "Entebbe",
    "city": "Entebbe",
    "country": "UG",
    "lat": 0.04
  },
  {
    "icao": "HRYR",
    "iata": "KGL",
    "name": "Kigali",
    "city": "Kigali",
    "country": "RW",
    "lat": -1.97
  },
  {
    "icao": "HBBA",
    "iata": "BJM",
    "name": "Bujumbura Melchior Ndadaye",
    "city": "Bujumbura",
    "country": "BI",
    "lat": -3.32
  },
  {
    "icao": "FZAA",
    "iata": "FIH",
    "name": "N'djili",
    "city": "Kinshasa",
    "country": "CD",
    "lat": -4.39
  },
  {
    "icao": "FLLB",
    "iata": "LVI",
    "name": "Harry Mwanga Nkumbula",
    "city": "Livingstone",
    "country": "ZM",
    "lat": -17.82
  },
  {
    "icao": "FBSK",
    "iata": "GBE",
    "name": "Sir Seretse Khama",
    "city": "Gaborone",
    "country": "BW",
    "lat": -24.56
  },
  {
    "icao": "FWCL",
    "iata": "BLZ",
    "name": "Chileka",
    "city": "Blantyre",
    "country": "MW",
    "lat": -15.68
  },
  {
    "icao": "FQMA",
    "iata": "MPM",
    "name": "Maputo",
    "city": "Maputo",
    "country": "MZ",
    "lat": -26.04
  },
  {
    "icao": "FYWH",
    "iata": "WDH",
    "name": "Hosea Kutako",
    "city": "Windhoek",
    "country": "NA",
    "lat": -22.48
  },
  {
    "icao": "FABL",
    "iata": "BFN",
    "name": "Bram Fischer",
    "city": "Bloemfontein",
    "country": "ZA",
    "lat": -29.1
  },
  {
    "icao": "FAPE",
    "iata": "PLZ",
    "name": "Chief Dawid Stuurman",
    "city": "Port Elizabeth",
    "country": "ZA",
    "lat": -33.98
  },
  {
    "icao": "FAKN",
    "iata": "MQP",
    "name": "Kruger Mpumalanga",
    "city": "Nelspruit",
    "country": "ZA",
    "lat": -25.38
  },
  {
    "icao": "FCBB",
    "iata": "BZV",
    "name": "Maya-Maya",
    "city": "Brazzaville",
    "country": "CG",
    "lat": -4.25
  },
  {
    "icao": "FOON",
    "iata": "POG",
    "name": "Port-Gentil",
    "city": "Port-Gentil",
    "country": "GA",
    "lat": -0.71
  },
  {
    "icao": "FOOL",
    "iata": "LBV",
    "name": "Leon Mba",
    "city": "Libreville",
    "country": "GA",
    "lat": 0.46
  },
  {
    "icao": "FKKD",
    "iata": "DLA",
    "name": "Douala International",
    "city": "Douala",
    "country": "CM",
    "lat": 4.01
  },
  {
    "icao": "FKYS",
    "iata": "NSI",
    "name": "Yaounde Nsimalen",
    "city": "Yaounde",
    "country": "CM",
    "lat": 3.72
  },
  {
    "icao": "DBBB",
    "iata": "COO",
    "name": "Cadjehoun",
    "city": "Cotonou",
    "country": "BJ",
    "lat": 6.36
  },
  {
    "icao": "DXXX",
    "iata": "LFW",
    "name": "Lome Tokoin",
    "city": "Lome",
    "country": "TG",
    "lat": 6.17
  },
  {
    "icao": "GQNO",
    "iata": "NKC",
    "name": "Nouakchott Oumtounsy",
    "city": "Nouakchott",
    "country": "MR",
    "lat": 18.1
  },
  {
    "icao": "GUCY",
    "iata": "CKY",
    "name": "Conakry",
    "city": "Conakry",
    "country": "GN",
    "lat": 9.58
  },
  {
    "icao": "GVNP",
    "iata": "RAI",
    "name": "Nelson Mandela",
    "city": "Praia",
    "country": "CV",
    "lat": 14.92
  },
  {
    "icao": "GVSV",
    "iata": "VXE",
    "name": "Cesaria Evora",
    "city": "Sao Vicente",
    "country": "CV",
    "lat": 16.83
  },
  {
    "icao": "FMEE",
    "iata": "RUN",
    "name": "Roland Garros",
    "city": "Saint-Denis",
    "country": "RE",
    "lat": -20.89
  },
  {
    "icao": "FMCZ",
    "iata": "DZA",
    "name": "Dzaoudzi Pamandzi",
    "city": "Dzaoudzi",
    "country": "YT",
    "lat": -12.8
  },
  {
    "icao": "KBNA",
    "iata": "BNA",
    "name": "Nashville International",
    "city": "Nashville",
    "country": "US",
    "lat": 36.12
  },
  {
    "icao": "KMKE",
    "iata": "MKE",
    "name": "Milwaukee Mitchell",
    "city": "Milwaukee",
    "country": "US",
    "lat": 42.95
  },
  {
    "icao": "KCVG",
    "iata": "CVG",
    "name": "Cincinnati Northern Kentucky",
    "city": "Cincinnati",
    "country": "US",
    "lat": 39.05
  },
  {
    "icao": "KOMA",
    "iata": "OMA",
    "name": "Eppley Airfield",
    "city": "Omaha",
    "country": "US",
    "lat": 41.3
  },
  {
    "icao": "KMCI",
    "iata": "MCI",
    "name": "Kansas City International",
    "city": "Kansas City",
    "country": "US",
    "lat": 39.3
  },
  {
    "icao": "KRSW",
    "iata": "RSW",
    "name": "Southwest Florida",
    "city": "Fort Myers",
    "country": "US",
    "lat": 26.54
  },
  {
    "icao": "KABQ",
    "iata": "ABQ",
    "name": "Albuquerque Sunport",
    "city": "Albuquerque",
    "country": "US",
    "lat": 35.04
  },
  {
    "icao": "KSJC",
    "iata": "SJC",
    "name": "San Jose Mineta",
    "city": "San Jose",
    "country": "US",
    "lat": 37.36
  },
  {
    "icao": "KOAK",
    "iata": "OAK",
    "name": "Oakland International",
    "city": "Oakland",
    "country": "US",
    "lat": 37.72
  },
  {
    "icao": "KSMF",
    "iata": "SMF",
    "name": "Sacramento International",
    "city": "Sacramento",
    "country": "US",
    "lat": 38.7
  },
  {
    "icao": "KBUF",
    "iata": "BUF",
    "name": "Buffalo Niagara",
    "city": "Buffalo",
    "country": "US",
    "lat": 42.94
  },
  {
    "icao": "KPBI",
    "iata": "PBI",
    "name": "Palm Beach International",
    "city": "West Palm Beach",
    "country": "US",
    "lat": 26.68
  },
  {
    "icao": "KMSY",
    "iata": "MSY",
    "name": "Louis Armstrong New Orleans",
    "city": "New Orleans",
    "country": "US",
    "lat": 29.99
  },
  {
    "icao": "KRIC",
    "iata": "RIC",
    "name": "Richmond International",
    "city": "Richmond",
    "country": "US",
    "lat": 37.51
  },
  {
    "icao": "KJAN",
    "iata": "JAN",
    "name": "Jackson-Medgar Wiley Evers",
    "city": "Jackson",
    "country": "US",
    "lat": 32.31
  },
  {
    "icao": "KBDL",
    "iata": "BDL",
    "name": "Bradley International",
    "city": "Hartford",
    "country": "US",
    "lat": 41.94
  },
  {
    "icao": "KPVD",
    "iata": "PVD",
    "name": "T F Green",
    "city": "Providence",
    "country": "US",
    "lat": 41.72
  },
  {
    "icao": "KSDF",
    "iata": "SDF",
    "name": "Louisville Muhammad Ali",
    "city": "Louisville",
    "country": "US",
    "lat": 38.17
  },
  {
    "icao": "KPWM",
    "iata": "PWM",
    "name": "Portland International Jetport",
    "city": "Portland",
    "country": "US",
    "lat": 43.65
  },
  {
    "icao": "KBTV",
    "iata": "BTV",
    "name": "Burlington International",
    "city": "Burlington",
    "country": "US",
    "lat": 44.47
  },
  {
    "icao": "KDSM",
    "iata": "DSM",
    "name": "Des Moines International",
    "city": "Des Moines",
    "country": "US",
    "lat": 41.53
  },
  {
    "icao": "KTUL",
    "iata": "TUL",
    "name": "Tulsa International",
    "city": "Tulsa",
    "country": "US",
    "lat": 36.2
  },
  {
    "icao": "KOKC",
    "iata": "OKC",
    "name": "Will Rogers World",
    "city": "Oklahoma City",
    "country": "US",
    "lat": 35.39
  },
  {
    "icao": "KBOI",
    "iata": "BOI",
    "name": "Boise",
    "city": "Boise",
    "country": "US",
    "lat": 43.56
  },
  {
    "icao": "KELP",
    "iata": "ELP",
    "name": "El Paso International",
    "city": "El Paso",
    "country": "US",
    "lat": 31.81
  },
  {
    "icao": "KTUS",
    "iata": "TUS",
    "name": "Tucson International",
    "city": "Tucson",
    "country": "US",
    "lat": 32.12
  },
  {
    "icao": "CYQB",
    "iata": "YQB",
    "name": "Quebec City Jean Lesage",
    "city": "Quebec City",
    "country": "CA",
    "lat": 46.79
  },
  {
    "icao": "CYXE",
    "iata": "YXE",
    "name": "Saskatoon John G Diefenbaker",
    "city": "Saskatoon",
    "country": "CA",
    "lat": 52.17
  },
  {
    "icao": "CYYJ",
    "iata": "YYJ",
    "name": "Victoria International",
    "city": "Victoria",
    "country": "CA",
    "lat": 48.65
  },
  {
    "icao": "CYQR",
    "iata": "YQR",
    "name": "Regina International",
    "city": "Regina",
    "country": "CA",
    "lat": 50.43
  },
  {
    "icao": "CYYT",
    "iata": "YYT",
    "name": "St Johns",
    "city": "St Johns",
    "country": "CA",
    "lat": 47.62
  },
  {
    "icao": "CYHM",
    "iata": "YHM",
    "name": "John C Munro Hamilton",
    "city": "Hamilton",
    "country": "CA",
    "lat": 43.17
  },
  {
    "icao": "CYQM",
    "iata": "YQM",
    "name": "Greater Moncton Roméo LeBlanc",
    "city": "Moncton",
    "country": "CA",
    "lat": 46.11
  },
  {
    "icao": "CYFC",
    "iata": "YFC",
    "name": "Fredericton International",
    "city": "Fredericton",
    "country": "CA",
    "lat": 45.87
  },
  {
    "icao": "MMTO",
    "iata": "TLC",
    "name": "Toluca",
    "city": "Toluca",
    "country": "MX",
    "lat": 19.34
  },
  {
    "icao": "MMCZ",
    "iata": "CZM",
    "name": "Cozumel",
    "city": "Cozumel",
    "country": "MX",
    "lat": 20.52
  },
  {
    "icao": "MMSD",
    "iata": "SJD",
    "name": "San Jose del Cabo",
    "city": "San Jose del Cabo",
    "country": "MX",
    "lat": 23.15
  },
  {
    "icao": "MMHO",
    "iata": "HMO",
    "name": "Hermosillo",
    "city": "Hermosillo",
    "country": "MX",
    "lat": 29.1
  },
  {
    "icao": "MMVA",
    "iata": "VSA",
    "name": "Villahermosa",
    "city": "Villahermosa",
    "country": "MX",
    "lat": 17.99
  },
  {
    "icao": "MMOX",
    "iata": "OAX",
    "name": "Oaxaca Xoxocotlan",
    "city": "Oaxaca",
    "country": "MX",
    "lat": 17.0
  },
  {
    "icao": "MMAS",
    "iata": "AGU",
    "name": "Aguascalientes",
    "city": "Aguascalientes",
    "country": "MX",
    "lat": 21.7
  },
  {
    "icao": "MMZH",
    "iata": "IZT",
    "name": "Ixtepec",
    "city": "Ixtepec",
    "country": "MX",
    "lat": 16.45
  },
  {
    "icao": "MGGT",
    "iata": "GUA",
    "name": "La Aurora",
    "city": "Guatemala City",
    "country": "GT",
    "lat": 14.58
  },
  {
    "icao": "MHLM",
    "iata": "SAP",
    "name": "Ramon Villeda Morales",
    "city": "San Pedro Sula",
    "country": "HN",
    "lat": 15.45
  },
  {
    "icao": "MHTG",
    "iata": "TGU",
    "name": "Toncontin",
    "city": "Tegucigalpa",
    "country": "HN",
    "lat": 14.06
  },
  {
    "icao": "MNMG",
    "iata": "MGA",
    "name": "Augusto C Sandino",
    "city": "Managua",
    "country": "NI",
    "lat": 12.14
  },
  {
    "icao": "MSSS",
    "iata": "SAL",
    "name": "El Salvador International",
    "city": "San Salvador",
    "country": "SV",
    "lat": 13.44
  },
  {
    "icao": "MZBZ",
    "iata": "BZE",
    "name": "Philip S W Goldson",
    "city": "Belize City",
    "country": "BZ",
    "lat": 17.54
  },
  {
    "icao": "TFFR",
    "iata": "PTP",
    "name": "Pointe-a-Pitre",
    "city": "Pointe-a-Pitre",
    "country": "GP",
    "lat": 16.27
  },
  {
    "icao": "TFFF",
    "iata": "FDF",
    "name": "Martinique Aime Cesaire",
    "city": "Fort-de-France",
    "country": "MQ",
    "lat": 14.59
  },
  {
    "icao": "TTPP",
    "iata": "POS",
    "name": "Piarco",
    "city": "Port of Spain",
    "country": "TT",
    "lat": 10.6
  },
  {
    "icao": "SYCJ",
    "iata": "GEO",
    "name": "Cheddi Jagan",
    "city": "Georgetown",
    "country": "GY",
    "lat": 6.5
  },
  {
    "icao": "SMJP",
    "iata": "PBM",
    "name": "Johan Adolf Pengel",
    "city": "Paramaribo",
    "country": "SR",
    "lat": 5.45
  },
  {
    "icao": "SOCA",
    "iata": "CAY",
    "name": "Felix Eboue",
    "city": "Cayenne",
    "country": "GF",
    "lat": 4.82
  },
  {
    "icao": "TAPA",
    "iata": "ANU",
    "name": "V C Bird",
    "city": "St Johns",
    "country": "AG",
    "lat": 17.14
  },
  {
    "icao": "TKPK",
    "iata": "SKB",
    "name": "Robert L Bradshaw",
    "city": "Basseterre",
    "country": "KN",
    "lat": 17.31
  },
  {
    "icao": "SBFZ",
    "iata": "FOR",
    "name": "Pinto Martins",
    "city": "Fortaleza",
    "country": "BR",
    "lat": -3.78
  },
  {
    "icao": "SBBE",
    "iata": "BEL",
    "name": "Val-de-Cans",
    "city": "Belem",
    "country": "BR",
    "lat": -1.38
  },
  {
    "icao": "SBEG",
    "iata": "MAO",
    "name": "Eduardo Gomes",
    "city": "Manaus",
    "country": "BR",
    "lat": -3.04
  },
  {
    "icao": "SBCT",
    "iata": "CWB",
    "name": "Afonso Pena",
    "city": "Curitiba",
    "country": "BR",
    "lat": -25.53
  },
  {
    "icao": "SBFL",
    "iata": "FLN",
    "name": "Hercilio Luz",
    "city": "Florianopolis",
    "country": "BR",
    "lat": -27.67
  },
  {
    "icao": "SBNF",
    "iata": "NVT",
    "name": "Navegantes",
    "city": "Navegantes",
    "country": "BR",
    "lat": -26.88
  },
  {
    "icao": "SBCF",
    "iata": "CNF",
    "name": "Tancredo Neves",
    "city": "Belo Horizonte",
    "country": "BR",
    "lat": -19.63
  },
  {
    "icao": "SBGO",
    "iata": "GYN",
    "name": "Santa Genoveva",
    "city": "Goiania",
    "country": "BR",
    "lat": -16.63
  },
  {
    "icao": "SAAR",
    "iata": "ROS",
    "name": "Rosario Islas Malvinas",
    "city": "Rosario",
    "country": "AR",
    "lat": -32.9
  },
  {
    "icao": "SAVC",
    "iata": "CRD",
    "name": "Comodoro Rivadavia",
    "city": "Comodoro Rivadavia",
    "country": "AR",
    "lat": -45.79
  },
  {
    "icao": "SAWH",
    "iata": "USH",
    "name": "Ushuaia Malvinas Argentinas",
    "city": "Ushuaia",
    "country": "AR",
    "lat": -54.84
  },
  {
    "icao": "SAZS",
    "iata": "BRC",
    "name": "San Carlos de Bariloche",
    "city": "Bariloche",
    "country": "AR",
    "lat": -41.15
  },
  {
    "icao": "SCIE",
    "iata": "CCP",
    "name": "Carriel Sur",
    "city": "Concepcion",
    "country": "CL",
    "lat": -36.77
  },
  {
    "icao": "SCFA",
    "iata": "ANF",
    "name": "Cerro Moreno",
    "city": "Antofagasta",
    "country": "CL",
    "lat": -23.44
  },
  {
    "icao": "SCDA",
    "iata": "IQQ",
    "name": "Diego Aracena",
    "city": "Iquique",
    "country": "CL",
    "lat": -20.54
  },
  {
    "icao": "SCCI",
    "iata": "PUQ",
    "name": "Carlos Ibanez del Campo",
    "city": "Punta Arenas",
    "country": "CL",
    "lat": -53.0
  },
  {
    "icao": "SPZO",
    "iata": "CUZ",
    "name": "Alejandro Velasco Astete",
    "city": "Cusco",
    "country": "PE",
    "lat": -13.54
  },
  {
    "icao": "SPQU",
    "iata": "AQP",
    "name": "Rodriguez Ballon",
    "city": "Arequipa",
    "country": "PE",
    "lat": -16.34
  },
  {
    "icao": "SUMU",
    "iata": "MVD",
    "name": "Carrasco",
    "city": "Montevideo",
    "country": "UY",
    "lat": -34.84
  },
  {
    "icao": "SUPE",
    "iata": "PDP",
    "name": "Capitan de Corbeta Carlos A Curbelo",
    "city": "Punta del Este",
    "country": "UY",
    "lat": -34.86
  },
  {
    "icao": "SVCB",
    "iata": "MAR",
    "name": "La Chinita",
    "city": "Maracaibo",
    "country": "VE",
    "lat": 10.56
  },
  {
    "icao": "SVVA",
    "iata": "VLN",
    "name": "Arturo Michelena",
    "city": "Valencia",
    "country": "VE",
    "lat": 10.15
  },
  {
    "icao": "SLVR",
    "iata": "VVI",
    "name": "Viru Viru",
    "city": "Santa Cruz",
    "country": "BO",
    "lat": -17.64
  },
  {
    "icao": "SLCB",
    "iata": "CBB",
    "name": "Jorge Wilstermann",
    "city": "Cochabamba",
    "country": "BO",
    "lat": -17.42
  },
  {
    "icao": "YSRI",
    "iata": "SYD",
    "name": "Sydney",
    "city": "Sydney",
    "country": "AU",
    "lat": -33.95
  },
  {
    "icao": "YBTL",
    "iata": "TSV",
    "name": "Townsville",
    "city": "Townsville",
    "country": "AU",
    "lat": -19.25
  },
  {
    "icao": "YBAS",
    "iata": "ASP",
    "name": "Alice Springs",
    "city": "Alice Springs",
    "country": "AU",
    "lat": -23.81
  },
  {
    "icao": "YBMK",
    "iata": "MKY",
    "name": "Mackay",
    "city": "Mackay",
    "country": "AU",
    "lat": -21.17
  },
  {
    "icao": "NZDN",
    "iata": "DUD",
    "name": "Dunedin",
    "city": "Dunedin",
    "country": "NZ",
    "lat": -45.93
  },
  {
    "icao": "NZPM",
    "iata": "PMR",
    "name": "Palmerston North",
    "city": "Palmerston North",
    "country": "NZ",
    "lat": -40.32
  },
  {
    "icao": "NZHN",
    "iata": "HLZ",
    "name": "Hamilton",
    "city": "Hamilton",
    "country": "NZ",
    "lat": -37.87
  },
  {
    "icao": "NZRO",
    "iata": "ROT",
    "name": "Rotorua",
    "city": "Rotorua",
    "country": "NZ",
    "lat": -38.11
  },
  {
    "icao": "NZNR",
    "iata": "NPE",
    "name": "Napier Hastings",
    "city": "Napier",
    "country": "NZ",
    "lat": -39.47
  },
  {
    "icao": "NCRG",
    "iata": "RAR",
    "name": "Rarotonga",
    "city": "Rarotonga",
    "country": "CK",
    "lat": -21.2
  },
  {
    "icao": "NTAA",
    "iata": "PPT",
    "name": "Faaa",
    "city": "Papeete",
    "country": "PF",
    "lat": -17.56
  },
  {
    "icao": "NWWW",
    "iata": "NOU",
    "name": "La Tontouta",
    "city": "Noumea",
    "country": "NC",
    "lat": -22.01
  },
  {
    "icao": "NSFA",
    "iata": "APW",
    "name": "Faleolo",
    "city": "Apia",
    "country": "WS",
    "lat": -13.83
  },
  {
    "icao": "NVVV",
    "iata": "VLI",
    "name": "Bauerfield",
    "city": "Port Vila",
    "country": "VU",
    "lat": -17.7
  },
  {
    "icao": "PGUM",
    "iata": "GUM",
    "name": "Antonio B Won Pat",
    "city": "Hagatna",
    "country": "GU",
    "lat": 13.48
  },
  {
    "icao": "PTPN",
    "iata": "PNI",
    "name": "Pohnpei",
    "city": "Pohnpei",
    "country": "FM",
    "lat": 6.98
  },
  {
    "icao": "ZMUB",
    "iata": "UBN",
    "name": "Chinggis Khaan",
    "city": "Ulaanbaatar",
    "country": "MN",
    "lat": 47.84
  },
  {
    "icao": "VNLK",
    "iata": "LUA",
    "name": "Lukla Tenzing-Hillary",
    "city": "Lukla",
    "country": "NP",
    "lat": 27.69
  },
  {
    "icao": "VQPR",
    "iata": "PBH",
    "name": "Paro",
    "city": "Paro",
    "country": "BT",
    "lat": 27.4
  }
]